(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[812],{

/***/ 87083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultError */
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58828);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var chime_ui_components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29947);
/* harmony import */ var chime_ui_components_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92061);
/* harmony import */ var chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50152);
/* harmony import */ var chime_ui_system_media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68574);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23991);
/* harmony import */ var components_Layout_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45651);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;













var ErrorContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .Content */ .VY)(_templateObject || (_templateObject = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  padding: 3rem 0 0;\n"])));

var ErrorGeneric = function ErrorGeneric(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DefaultError, {}) : _ref$children,
      _ref$cta = _ref.cta,
      cta = _ref$cta === void 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chime_ui_components_Button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
    as: "a",
    href: "https://help.chime.com/hc/en-us/articles/23918862092567-How-can-I-troubleshoot-issues-with-claiming-Pay-Anyone-Transfers-if-I-m-not-a-Chime-member",
    children: "Get Help"
  }) : _ref$cta,
      showLogin = _ref.showLogin;
  var isMobileScreenSize = (0,react_use__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("(max-width: ".concat(chime_ui_system_media__WEBPACK_IMPORTED_MODULE_4__/* .screenSizes.tablet */ .f.tablet - 1, "px)"));

  var FooterWithCTA = function FooterWithCTA() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(FooterLayout, {
      children: [!!cta && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(CTALayout, {
        children: cta
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(CopyrightLayout, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .CopyrightText */ .mr, {})
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
      header: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_Layout_Header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        showLogin: showLogin
      }),
      footer: isMobileScreenSize && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FooterWithCTA, {}),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .ContentWrapper */ .vs, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(ErrorContent, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chime_ui_components_Icons__WEBPACK_IMPORTED_MODULE_2__/* .ErrorIcon */ .Pz, {}), children]
        })
      }), !isMobileScreenSize && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(CTALayout, {
        children: cta
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorGeneric);
var DefaultError = function DefaultError() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .SmallTitle */ .h7, {
      children: "Something went wrong"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .StandardText */ .nn, {
      children: "We're working on it. Please try again later or contact our Member Services team if you need more support."
    })]
  });
};
var CTALayout = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject2 || (_templateObject2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  padding: 1.5rem 0;\n\n  ", "\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileOnly */ .Z.mobileOnly(_templateObject3 || (_templateObject3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n    padding: 1.5rem;\n  "]))));
var CopyrightLayout = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject4 || (_templateObject4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  text-align: center;\n  font-size: 9px;\n  margin: 0 0 0.5rem 0;\n"])));
var FooterLayout = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject5 || (_templateObject5 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"])));

/***/ }),

/***/ 71195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ Pay_PayAnyoneToken; },
  "t": function() { return /* reexport */ Request_ReceiveFromAnyoneToken; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@xstate/react/es/useMachine.js + 6 modules
var useMachine = __webpack_require__(24553);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 6 modules
var AnimatePresence = __webpack_require__(66473);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.js + 22 modules
var motion_minimal = __webpack_require__(48786);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/xstate/es/actions.js
var actions = __webpack_require__(30375);
// EXTERNAL MODULE: ./node_modules/xstate/es/Machine.js + 2 modules
var Machine = __webpack_require__(4723);
// EXTERNAL MODULE: ./src/utils/segment/trackingEvents.ts
var trackingEvents = __webpack_require__(79233);
;// CONCATENATED MODULE: ./src/machines/navigationMachine.ts


var _excluded = ["type"],
    _excluded2 = ["type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getToken = (0,actions/* assign */.f0)( // eslint-disable-next-line @typescript-eslint/no-unused-vars
function (context, _ref) {
  var type = _ref.type,
      event = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return {
    token: event.token,
    publicId: event.publicId
  };
});
var getClaimInfo = (0,actions/* assign */.f0)({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  claimInfo: function claimInfo(context, _ref2) {
    var type = _ref2.type,
        event = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

    return _objectSpread(_objectSpread({}, context.claimInfo), event);
  }
});
var getError = (0,actions/* assign */.f0)({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error: function error(_, event) {
    return {
      id: event.error_id,
      header: event.error_header,
      body: event.error_body
    };
  }
});
var navigationMachine = (0,Machine/* createMachine */.C)({
  id: 'navigation',
  initial: 'loading',
  context: {
    token: undefined,
    publicId: undefined,
    claimInfo: {},
    error: undefined
  },
  states: {
    loading: {
      on: {
        TOKEN: {
          actions: ['getToken']
        },
        RETURN_USER_LANDING: {
          target: 'returnUserLanding'
        },
        NEXT: {
          target: 'landing'
        }
      }
    },
    landing: {
      on: {
        RETURN_USER_LANDING: {
          target: 'returnUserLanding'
        },
        NEXT: {
          target: 'claimInfo',
          actions: [function (context) {
            (0,trackingEvents/* trackCTATapped */.u)('Pay Anyone', 'Claim for free', 'Landing Page', 'pay_anyone_landing_next_button', context.publicId);
          }]
        }
      }
    },
    returnUserLanding: {
      on: {
        NEXT: {
          target: 'confirmation',
          actions: [function (context) {
            (0,trackingEvents/* trackCTATapped */.u)('Pay Anyone', 'Return User Transfer', 'Return User Landing Page', 'pay_anyone_reuse_debit_card_transfer_button', context.publicId);
          }]
        },
        CHANGE_CARD: {
          target: 'claimInfo'
        },
        ERROR_PAGE: {
          target: 'error',
          actions: ['getError']
        }
      }
    },
    claimInfo: {
      on: {
        NEXT: {
          target: 'confirmation',
          actions: ['getClaimInfo']
        },
        //TODO: Temporal to enable testing for RFA confirmation. Will remove in https://chime.atlassian.net/browse/PAGE-438
        NEXT_RECEIVE: {
          target: 'receiveFromAnyoneConfirmation'
        },
        ERROR_PAGE: {
          target: 'error',
          actions: ['getError']
        }
      }
    },
    error: {
      type: 'final'
    },
    confirmation: {
      type: 'final'
    },
    receiveFromAnyoneConfirmation: {
      type: 'final'
    }
  }
}, {
  actions: {
    getToken: getToken,
    getClaimInfo: getClaimInfo,
    getError: getError
  }
});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 5 modules
var useCookies = __webpack_require__(46440);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./src/chime-ui/components/Spinner/index.tsx + 1 modules
var Spinner = __webpack_require__(4850);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@1debit/step-up/dist/index.js + 136 modules
var dist = __webpack_require__(29081);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(75178);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(69273);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/chime-ui/components/Button/index.tsx
var components_Button = __webpack_require__(29947);
// EXTERNAL MODULE: ./src/chime-ui/system/index.ts
var system = __webpack_require__(68526);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/chime-ui/components/Checkbox/Checkbox.tsx




var Checkbox_excluded = ["defaultChecked", "onChange", "children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function Checkbox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Checkbox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Checkbox_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Checkbox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Icon = styled_components_browser_esm/* default.svg.attrs */.ZP.svg.attrs({
  viewBox: '0 0 14 11',
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    d: "M13.5474 1.51224L5.54784 10.0451.501953 5.55984 1.4985 4.43873l3.95411 3.51476L12.4531.486328l1.0943 1.025912z"
  })
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: ", ";\n"])), system/* colors.white */.O9.white);
var StyledCheckbox = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  cursor: default;\n  display: inline-block;\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  background: ", ";\n  border: solid 2px ", ";\n  border-radius: 0.25rem;\n  margin-right: 1.125rem;\n  transition: all ", "s;\n"])), function (_ref) {
  var checked = _ref.checked;
  return checked ? system/* colors.darkGreen */.O9.darkGreen : system/* colors.white */.O9.white;
}, system/* colors.darkGreen */.O9.darkGreen, system/* values.TIMEOUT_DELAY */.VO.TIMEOUT_DELAY);
var StyledCustomCheckboxInput = styled_components_browser_esm/* default.input */.ZP.input(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 1;\n  cursor: inherit;\n"])));
var StyledLabel = styled_components_browser_esm/* default.label */.ZP.label(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-bottom: 1rem;\n\n  a {\n    font-weight: 700;\n\n    &:hover,\n    &:focus {\n      outline: none;\n      color: ", ";\n    }\n\n    &:active,\n    &:visited {\n      color: inherit;\n    }\n  }\n"])), system/* colors.notBlack */.O9.notBlack);
var ForwardedCheckbox = /*#__PURE__*/react.forwardRef(function Checkbox(_ref2, ref) {
  var _ref2$defaultChecked = _ref2.defaultChecked,
      defaultChecked = _ref2$defaultChecked === void 0 ? false : _ref2$defaultChecked,
      onChange = _ref2.onChange,
      children = _ref2.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, Checkbox_excluded);

  var _React$useState = react.useState(defaultChecked),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      checkedState = _React$useState2[0],
      setChecked = _React$useState2[1];

  var handleOnChange = function handleOnChange(event) {
    setChecked(event.target.checked);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLabel, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCheckbox, {
      checked: checkedState,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledCustomCheckboxInput, Checkbox_objectSpread(Checkbox_objectSpread({
        type: "checkbox",
        defaultChecked: defaultChecked,
        onChange: handleOnChange
      }, props), {}, {
        ref: ref
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {})]
    }), children]
  });
});
/* harmony default export */ var Checkbox = (ForwardedCheckbox);
// EXTERNAL MODULE: ./src/chime-ui/components/Icons/index.tsx
var Icons = __webpack_require__(92061);
// EXTERNAL MODULE: ./src/chime-ui/components/Modal/index.tsx + 2 modules
var components_Modal = __webpack_require__(47255);
;// CONCATENATED MODULE: ./src/chime-ui/components/TextField/InlineErrorMessage.tsx


var InlineErrorMessage_templateObject, InlineErrorMessage_templateObject2;








var InlineErrorMessage = function InlineErrorMessage(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDownAnimation, {
    initial: {
      scaleY: 0
    },
    animate: {
      scaleY: 1
    },
    exit: {
      scaleY: 0
    },
    transition: {
      type: 'easeIn',
      delay: system/* values.TIMEOUT_DELAY */.VO.TIMEOUT_DELAY
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(MessageText, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* WarningIcon */.aN, {}), children]
    })
  });
};

var SlideDownAnimation = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(InlineErrorMessage_templateObject || (InlineErrorMessage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  transform-origin: 50% 0;\n"])));
var MessageText = styled_components_browser_esm/* default.p */.ZP.p(InlineErrorMessage_templateObject2 || (InlineErrorMessage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: baseline;\n  margin: 0;\n  height: auto;\n  box-sizing: border-box;\n  padding: 0.5rem 0;\n  font-weight: 300;\n  line-height: 1rem;\n  background: none;\n  color: ", ";\n  border-radius: 0;\n  font-size: 0.75rem;\n  margin: 0 0;\n  box-sizing: border-box;\n"])), system/* colors.alertRed */.O9.alertRed);
/* harmony default export */ var TextField_InlineErrorMessage = (InlineErrorMessage);
;// CONCATENATED MODULE: ./src/chime-ui/components/TextField/Input.tsx




var Input_templateObject, Input_templateObject2, Input_templateObject3, Input_templateObject4, _templateObject5;

var Input_excluded = ["endAdornment", "hasError"];

function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Input_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ForwardedInput = /*#__PURE__*/react.forwardRef(function Input(_ref, ref) {
  var endAdornment = _ref.endAdornment,
      hasError = _ref.hasError,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Input_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputContainer, {
    hasError: hasError,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledInput, Input_objectSpread({
      ref: ref
    }, props)), endAdornment]
  });
});
/* harmony default export */ var Input = (ForwardedInput);
var onAutoFillStart = (0,styled_components_browser_esm/* keyframes */.F4)(Input_templateObject || (Input_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {}\n"])));
var onAutoFillCancel = (0,styled_components_browser_esm/* keyframes */.F4)(Input_templateObject2 || (Input_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  to{}\n"])));
var StyledInput = styled_components_browser_esm/* default.input */.ZP.input(Input_templateObject3 || (Input_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  min-width: 0;\n  font-weight: 400;\n  font-family: inherit;\n  color: inherit;\n  outline: none;\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  position: relative;\n  line-height: 1.375rem;\n  margin: 1.5rem 0.5rem 0.5rem;\n  /** this normalizes between safari and others */\n  padding: 1px 2px;\n\n  &:focus {\n    &::placeholder {\n      color: inherit;\n      opacity: 1;\n    }\n  }\n\n  &::placeholder {\n    opacity: 0;\n  }\n\n  &:-ms-input-placeholder {\n    opacity: 1;\n    color: transparent;\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &:-webkit-autofill {\n    animation: ", ";\n  }\n\n  &:not(:-webkit-autofill) {\n    animation: ", ";\n  }\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    /** super hacky css to get rid of the autofill background */\n    transition: background-color 9999s ease-out;\n  }\n"])), onAutoFillStart, onAutoFillCancel);
var InputContainer = styled_components_browser_esm/* default.div */.ZP.div(Input_templateObject4 || (Input_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0px;\n  background-color: transparent;\n  border-radius: 0.5rem;\n  display: flex;\n  position: relative;\n  border: solid 2px ", ";\n  border-radius: 0.5rem;\n  height: 4rem;\n\n  &:focus-within {\n    border: solid 2px ", ";\n    &::placeholder {\n      color: inherit;\n      opacity: 1;\n    }\n  }\n\n  ", ";\n"])), system/* colors.lightGrey */.O9.lightGrey, system/* colors.brightGreen */.O9.brightGreen, function (props) {
  return props.hasError && (0,styled_components_browser_esm/* css */.iv)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      background-color: ", ";\n      border: solid 2px ", ";\n\n      &:focus-within {\n        background-color: transparent;\n      }\n    "])), system/* colors.tint.alertRed.a10 */.O9.tint.alertRed.a10, system/* colors.alertRed */.O9.alertRed);
});
;// CONCATENATED MODULE: ./src/chime-ui/components/TextField/Label.tsx


var Label_templateObject, Label_templateObject2, Label_templateObject3;



var Label = styled_components_browser_esm/* default.label */.ZP.label(Label_templateObject || (Label_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: inline-block;\n  color: ", ";\n  line-height: 1.25rem;\n  margin: 0 0 5px;\n  position: absolute;\n  transition: 0.2s ease all;\n\n  ", "\n\n  ", ";\n"])), system/* colors.darkGrey */.O9.darkGrey, function (props) {
  return props.isEmpty && (0,styled_components_browser_esm/* css */.iv)(Label_templateObject2 || (Label_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 22px;\n      left: 13px;\n      cursor: text;\n    "])));
}, function (props) {
  return (!props.isEmpty || props.isFocused) && (0,styled_components_browser_esm/* css */.iv)(Label_templateObject3 || (Label_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 0.5rem;\n      left: 13px;\n      font-size: 0.75rem;\n    "])));
});
/* harmony default export */ var TextField_Label = (Label);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/use-animation.js + 1 modules
var use_animation = __webpack_require__(18638);
;// CONCATENATED MODULE: ./src/chime-ui/components/TextField/Wiggler.tsx




var Wiggler = function Wiggler(_ref) {
  var doWiggle = _ref.doWiggle,
      children = _ref.children;
  var controls = (0,use_animation/* useAnimation */._)();
  (0,react.useEffect)(function () {
    if (doWiggle) {
      controls.start({
        x: ['0px', '12px', '-12px', '12px', '0px']
      });
    }
  }, [controls, doWiggle]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(motion_minimal.m.div, {
    initial: doWiggle,
    animate: controls,
    transition: {
      duration: 0.5,
      times: [0, 0.17, 0.5, 0.83, 1],
      ease: 'easeInOut'
    },
    children: children
  });
};

/* harmony default export */ var TextField_Wiggler = (Wiggler);
;// CONCATENATED MODULE: ./src/chime-ui/components/TextField/TextField.tsx




var TextField_templateObject;

var TextField_excluded = ["label", "name", "id", "hasError", "onFocus", "onBlur", "onChange", "onAutoFill", "onInput", "onAnimationStart"];

function TextField_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TextField_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TextField_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TextField_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ForwardedTextField = /*#__PURE__*/react.forwardRef(function TextField(_ref, ref) {
  var _innerRef$current;

  var label = _ref.label,
      name = _ref.name,
      id = _ref.id,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onAutoFill = _ref.onAutoFill,
      onInput = _ref.onInput,
      onAnimationStart = _ref.onAnimationStart,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, TextField_excluded);

  var _useState = (0,react.useState)(false),
      isFocused = _useState[0],
      setIsFocus = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isEmpty = _useState2[0],
      setIsEmpty = _useState2[1];

  var innerRef = useForwardedRef(ref);
  var inputValueLength = (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.value.length;
  (0,react.useEffect)(function () {
    var _innerRef$current2;

    // Ref has to be accessed again on load to ensure we get the initial provided value
    var inputValueLength = (_innerRef$current2 = innerRef.current) === null || _innerRef$current2 === void 0 ? void 0 : _innerRef$current2.value.length;

    if (inputValueLength > 0 && isEmpty) {
      setIsEmpty(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  (0,react.useEffect)(function () {
    if (inputValueLength > 0 && isEmpty) {
      if (onChange) {
        onChange({
          target: innerRef.current
        });
      }

      setIsEmpty(false);
    }
  }, [isEmpty, onChange, inputValueLength, innerRef]);

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    setIsFocus(true);
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    setIsFocus(false);
  };

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event);
    }

    if (event.target.value.length === 0 && !isEmpty) {
      setIsEmpty(true);
    } else if (isEmpty) {
      setIsEmpty(false);
    }
  };

  var handleAnimationStart = function handleAnimationStart(e) {
    if (onAnimationStart) {
      onAnimationStart(e);
    }

    if (!onAutoFill) return;

    if (e.animationName === onAutoFillStart.name) {
      autoComplete(e.target, onAutoFill);
    } else if (e.animationName === onAutoFillCancel.name) {
      cancelAutoComplete(e.target, onAutoFill);
    }
  };

  var handleInput = function handleInput(e) {
    if (onInput) {
      onInput(e);
    }

    if (!onAutoFill) return;
    var nativeEvent = e.nativeEvent;

    if ('insertReplacementText' === nativeEvent.inputType || !('data' in nativeEvent)) {
      autoComplete(e.target, onAutoFill);
    } else {
      cancelAutoComplete(e.target, onAutoFill);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(InputWrap, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextField_Wiggler, {
      doWiggle: hasError,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, TextField_objectSpread({
        ref: innerRef,
        name: name,
        id: id,
        hasError: hasError,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleChange,
        onAnimationStart: handleAnimationStart,
        onInput: handleInput
      }, props)), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_Label, {
        htmlFor: id,
        isEmpty: isEmpty,
        isFocused: isFocused,
        children: label
      })]
    })
  });
});
/* harmony default export */ var TextField = (ForwardedTextField);
var InputWrap = styled_components_browser_esm/* default.div */.ZP.div(TextField_templateObject || (TextField_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  /**\n   we gotta set the height here also because of older Safari\n   otherwise position relative will expand to the whole container height \n   */\n  height: 4rem;\n  min-width: 90px;\n  flex: 1 1 30%;\n"])));

function autoComplete(element, callback) {
  if (element.hasAttribute('autofilled')) return;
  element.setAttribute('autofilled', 'true');
  var event = new window.CustomEvent('autofill', {
    bubbles: true,
    cancelable: true,
    detail: {
      autoFilled: true
    }
  }); // no autofill if preventDefault is called

  if (!element.dispatchEvent(event)) {
    element.value = '';
  }

  if (callback) {
    callback(event);
  }
}

function cancelAutoComplete(element, callback) {
  if (!element.hasAttribute('autofilled')) return;
  element.removeAttribute('autofilled');
  var event = new window.CustomEvent('autofill', {
    bubbles: true,
    cancelable: false,
    detail: {
      autoFilled: false
    }
  }); // dispatch event

  element.dispatchEvent(event);

  if (callback) {
    callback(event);
  }
}

function useForwardedRef(ref) {
  var innerRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (!ref) return;

    if (typeof ref === 'function') {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  }, [ref]);
  return innerRef;
}
// EXTERNAL MODULE: ./src/chime-ui/components/Typography/index.tsx
var Typography = __webpack_require__(50152);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx
var Layout = __webpack_require__(23991);
// EXTERNAL MODULE: ./src/components/Layout/Header.tsx
var Header = __webpack_require__(45651);
// EXTERNAL MODULE: ./src/chime-ui/system/colors.ts
var colors = __webpack_require__(41234);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/normalizers.ts
var notANumberRegex = /[^0-9]/g;
var normalizeCardNumber = function normalizeCardNumber(value) {
  var _value$replace$match;

  return ((_value$replace$match = value.replace(notANumberRegex, '').match(/.{1,4}/g)) === null || _value$replace$match === void 0 ? void 0 : _value$replace$match.join(' ').substr(0, 19)) || '';
};
var normalizeExp = function normalizeExp(value) {
  return value.replace(/^([1-9]\/|[2-9])$/g, '0$1/' // 3 > 03/
  ).replace(/^(0[1-9]|1[0-2])$/g, '$1/' // 11 > 11/
  ).replace(/^([0-1])([3-9])$/g, '0$1/$2' // 13 > 01/3
  ).replace(/^(0?[1-9]|1[0-2])([0-9]{2})$/g, '$1/$2' // 141 > 01/41
  ).replace(/^(0?[1-9]|1[0-2])\/?20([0-9]{2})$/g, '$1/$2' // 122021 > 12/21
  ).replace(/^([1-9])\/([0-9]{2})$/g, '0$1/$2').replace(/^([0]+)\/|[0]+$/g, '0' // 0/ > 0 and 00 > 0
  ).replace(/[^\d/]|^[/]*$/g, '' // To allow only digits and `/`
  ).replace(/\/\//g, '/' // Prevent entering more than 1 `/`
  );
};
var normalizeCSC = function normalizeCSC(value) {
  return value.replace(notANumberRegex, '').substr(0, 3) || '';
};
var normalizePostalCode = function normalizePostalCode(value) {
  return value.replace(notANumberRegex, '').substr(0, 5) || '';
};
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/eventHandlers.ts

var handleExpdateEvents = {
  onKeyUp: function onKeyUp(event) {
    if (['Backspace', 'Delete'].indexOf(event.key) !== -1) {
      return;
    }

    var _ref = event.target,
        value = _ref.value;
    event.target.value = normalizeExp(value);
  }
};
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/getCardVendor.ts
var VISA_START_PATTERN = /^4/;
var MASTERCARD_START_PATTERN = /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/;
var DISCOVER_START_PATTERN = /^(6011|65|64[4-9]|622)/;
var CARD_TYPES = [{
  displayName: 'Visa',
  type: 'visa',
  startPattern: VISA_START_PATTERN
}, {
  displayName: 'Mastercard',
  type: 'mastercard',
  startPattern: MASTERCARD_START_PATTERN
}, {
  displayName: 'Discover',
  type: 'discover',
  startPattern: DISCOVER_START_PATTERN
}];
var getCardVendor = function getCardVendor(value) {
  return CARD_TYPES.find(function (cardType) {
    return cardType.startPattern.test(value);
  });
};
var UNKNOWN_CARD_TYPE = {
  displayName: 'Debit Card',
  type: 'unknown'
};
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/CardForm.tsx



var CardForm_templateObject, CardForm_templateObject2, CardForm_templateObject3, CardForm_templateObject4, CardForm_templateObject5, _templateObject6;

function CardForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function CardForm(_ref) {
  var _errors$cardnumber, _errors$expdate, _errors$csc, _errors$postalCode;

  var register = _ref.register,
      setValue = _ref.setValue,
      errors = _ref.errors,
      isSubmitted = _ref.isSubmitted,
      trackCVV = _ref.trackCVV,
      trackExpDate = _ref.trackExpDate,
      trackCardNumber = _ref.trackCardNumber,
      trackZipCode = _ref.trackZipCode,
      showBottomSheet = _ref.showBottomSheet,
      handleOnOcrClick = _ref.handleOnOcrClick,
      isCameraButtonShowing = _ref.isCameraButtonShowing,
      setCameraButtonShowing = _ref.setCameraButtonShowing,
      publicId = _ref.publicId;

  var _useState = (0,react.useState)(null),
      cardVendor = _useState[0],
      setCardVendor = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isCardNumberFocused = _useState2[0],
      setCardNumberFocused = _useState2[1];

  var onCardNumberFocus = function onCardNumberFocus() {
    return setCardNumberFocused(true);
  };

  var onCardNumberBlur = function onCardNumberBlur() {
    return setCardNumberFocused(false);
  };

  var handleCardVendor = function handleCardVendor(_ref2) {
    var value = _ref2.target.value;
    var normalizedCardNumber = normalizeCardNumber(value);
    setValue('cardnumber', normalizedCardNumber);
    setCardVendor(getCardVendor(normalizedCardNumber));

    if (setCameraButtonShowing) {
      setCameraButtonShowing(value);
    }
  };

  var onOcrClick = function onOcrClick() {
    if (handleOnOcrClick) {
      handleOnOcrClick();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CCRow, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField, CardForm_objectSpread(CardForm_objectSpread({}, register('cardnumber', {
        onBlur: function onBlur(e) {
          onCardNumberBlur();
          return trackCardNumber(e, publicId);
        },
        onChange: handleCardVendor
      })), {}, {
        id: 'cardnumber',
        label: 'Debit card number',
        autoComplete: "cc-number",
        type: "tel",
        inputMode: "numeric",
        hasError: !!errors.cardnumber && isSubmitted,
        onAutoFill: function onAutoFill(e) {
          return trackCardNumber(e, publicId);
        },
        onFocus: onCardNumberFocus,
        endAdornment: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [cardVendor && /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* CardVendorIcon */.TP, {
            icon: cardVendor.type,
            vendor: cardVendor.displayName
          }), isCameraButtonShowing && /*#__PURE__*/(0,jsx_runtime.jsx)(CameraButton, {
            onClick: onOcrClick,
            isCardNumberFocused: isCardNumberFocused
          })]
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: !!errors.cardnumber && isSubmitted && /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_InlineErrorMessage, {
        children: (_errors$cardnumber = errors.cardnumber) === null || _errors$cardnumber === void 0 ? void 0 : _errors$cardnumber.message
      }, 'cardnumber')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardDetailsRow, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextField, CardForm_objectSpread(CardForm_objectSpread({}, register('expdate')), {}, {
        id: 'expdate',
        label: 'MM/YY',
        maxLength: 5,
        autoComplete: "cc-exp",
        type: "tel",
        inputMode: "numeric",
        hasError: !!errors.expdate && isSubmitted,
        onBlur: function onBlur(e) {
          return trackExpDate(e, publicId);
        },
        onAutoFill: function onAutoFill(e) {
          return trackExpDate(e, publicId);
        },
        onKeyUp: handleExpdateEvents.onKeyUp
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField, CardForm_objectSpread(CardForm_objectSpread({}, register('csc', {
        onChange: function onChange(event) {
          var value = event.target.value;
          event.target.value = normalizeCSC(value);
        }
      })), {}, {
        id: 'csc',
        label: 'CVV',
        autoComplete: "cc-csc",
        type: "password",
        inputMode: "numeric",
        hasError: !!errors.csc && isSubmitted,
        onAutoFill: function onAutoFill(e) {
          return trackCVV(e, publicId);
        },
        onBlur: function onBlur(e) {
          return trackCVV(e, publicId);
        },
        endAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionIconLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* IconButton */.hU, {
            icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* QuestionCircleIcon */.pT, {}),
            onClick: showBottomSheet,
            "aria-label": 'question-icon'
          })
        })
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField, CardForm_objectSpread(CardForm_objectSpread({}, register('postalCode', {
        onChange: function onChange(event) {
          var value = event.target.value;
          event.target.value = normalizePostalCode(value);
        }
      })), {}, {
        id: 'postalCode',
        label: 'ZIP Code',
        autoComplete: "postal-code",
        type: "tel",
        inputMode: "numeric",
        hasError: !!errors.postalCode && isSubmitted,
        onAutoFill: function onAutoFill(e) {
          return trackZipCode(e, publicId);
        },
        onBlur: function onBlur(e) {
          return trackZipCode(e, publicId);
        }
      }))]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: !!errors.expdate && isSubmitted && /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_InlineErrorMessage, {
        children: (_errors$expdate = errors.expdate) === null || _errors$expdate === void 0 ? void 0 : _errors$expdate.message
      }, 'expdate')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: !!errors.csc && isSubmitted && /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_InlineErrorMessage, {
        children: (_errors$csc = errors.csc) === null || _errors$csc === void 0 ? void 0 : _errors$csc.message
      }, 'csc')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: !!errors.postalCode && isSubmitted && /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_InlineErrorMessage, {
        children: (_errors$postalCode = errors.postalCode) === null || _errors$postalCode === void 0 ? void 0 : _errors$postalCode.message
      }, 'postalCode')
    })]
  });
}

var CCRow = styled_components_browser_esm/* default.div */.ZP.div(CardForm_templateObject || (CardForm_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 0.5rem;\n"])));
var CardDetailsRow = styled_components_browser_esm/* default.div */.ZP.div(CardForm_templateObject2 || (CardForm_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: row wrap;\n  column-gap: 0.5rem;\n  padding-top: 0.5rem;\n"])));
var QuestionIconLayout = styled_components_browser_esm/* default.div */.ZP.div(CardForm_templateObject3 || (CardForm_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: flex-start;\n  padding: 0.5rem;\n"])));
var CameraButton = (0,styled_components_browser_esm/* default */.ZP)(components_Button/* Button */.zx).attrs({
  'aria-label': 'camera'
})(CardForm_templateObject4 || (CardForm_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 5rem;\n  border: none;\n  border-radius: 0;\n  height: 100%;\n  transition: all 0.3s ease 0s;\n\n  ", ";\n"])), function (props) {
  return props.isCardNumberFocused ? (0,styled_components_browser_esm/* css */.iv)(CardForm_templateObject5 || (CardForm_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n          background: ", "\n            url('", "cameraLargeBlack.svg') no-repeat center center;\n        "])), colors/* colors.brightGreen */.O9.brightGreen, Icons/* iconsPath */.VA) : (0,styled_components_browser_esm/* css */.iv)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n          background: url('", "cameraLargeGreen.svg') no-repeat center\n            center;\n        "])), Icons/* iconsPath */.VA);
});
/* harmony default export */ var ClaimInfo_CardForm = (CardForm);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js + 107 modules
var main = __webpack_require__(75389);
// EXTERNAL MODULE: ./node_modules/@microblink/blinkcard-in-browser-sdk/es/blinkcard-sdk.js
var blinkcard_sdk = __webpack_require__(36879);
// EXTERNAL MODULE: ./src/types/index.tsx + 1 modules
var types = __webpack_require__(20381);
// EXTERNAL MODULE: ./node_modules/@reach/dialog/dist/dialog.esm.js + 53 modules
var dialog_esm = __webpack_require__(73251);
;// CONCATENATED MODULE: ./src/machines/cardCaptureMachine.ts

var cardCaptureMachine = (0,Machine/* createMachine */.C)({
  id: 'cardCaptureState',
  initial: 'idle',
  states: {
    idle: {
      on: {
        START: {
          target: 'cardNumber'
        }
      }
    },
    cardNumber: {
      on: {
        ALIGN_CAMERA: {
          target: 'alignCameraToFrame'
        }
      }
    },
    alignCameraToFrame: {
      on: {
        RESUME: [{
          target: 'cardNumber'
        }]
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/features/startDebitCardScan.ts




function startDebitCardScan_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function startDebitCardScan_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? startDebitCardScan_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : startDebitCardScan_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function startDebitCardScan(_x, _x2, _x3, _x4, _x5, _x6) {
  return _startDebitCardScan.apply(this, arguments);
}

function _startDebitCardScan() {
  _startDebitCardScan = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(blinkCardWasmSdk, cameraFeed, onScanSuccess, setCancelScan, recognizerRunnerCallbacks, onError) {
    var videoRecognizer, blinkCardRecognizer, settings, recognizerRunner, _videoRecognizer3, selectedCamera, processResult, recognitionResult, reason;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (blinkCardWasmSdk) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return blinkcard_sdk/* createBlinkCardRecognizer */.Xw(blinkCardWasmSdk);

          case 4:
            blinkCardRecognizer = _context.sent;
            _context.next = 7;
            return blinkCardRecognizer === null || blinkCardRecognizer === void 0 ? void 0 : blinkCardRecognizer.currentSettings();

          case 7:
            settings = _context.sent;

            if (!(typeof settings === 'object' && settings !== null && settings !== undefined)) {
              _context.next = 12;
              break;
            }

            settings['extractCvv'] = false;
            _context.next = 12;
            return blinkCardRecognizer.updateSettings(settings);

          case 12:
            _context.next = 14;
            return blinkcard_sdk/* createRecognizerRunner */.Lz(blinkCardWasmSdk, [blinkCardRecognizer], true, startDebitCardScan_objectSpread(startDebitCardScan_objectSpread({}, recognizerRunnerCallbacks), {}, {
              onFirstSideResult: function onFirstSideResult() {
                var _videoRecognizer;

                // Cancel scan, this will complete the recognition and call onSuccess
                // @link: https://github.com/blinkcard/blinkcard-in-browser/blob/29ecdf830cff61b31b0ed69489e2fa6a94cab76b/src/MicroblinkSDK/VideoRecognizer.ts#L414
                (_videoRecognizer = videoRecognizer) === null || _videoRecognizer === void 0 ? void 0 : _videoRecognizer.cancelRecognition();
              }
            }));

          case 14:
            recognizerRunner = _context.sent;
            _context.prev = 15;
            _context.next = 18;
            return blinkcard_sdk/* selectCamera */.Ut(null, blinkcard_sdk/* PreferredCameraType.BackFacingCamera */.Ff.BackFacingCamera);

          case 18:
            selectedCamera = _context.sent;
            _context.next = 21;
            return blinkcard_sdk/* VideoRecognizer.createVideoRecognizerFromCameraStream */.Xu.createVideoRecognizerFromCameraStream(cameraFeed, recognizerRunner, (selectedCamera === null || selectedCamera === void 0 ? void 0 : selectedCamera.deviceId) || null);

          case 21:
            videoRecognizer = _context.sent;
            // Set the cancel function so that the videoRecognizer is within its closure
            setCancelScan({
              run: function run() {
                var _videoRecognizer2;

                (_videoRecognizer2 = videoRecognizer) === null || _videoRecognizer2 === void 0 ? void 0 : _videoRecognizer2.cancelRecognition();
              }
            }); // The recognize() method will hold runtime until the camera
            // has captured a card, capture is cancelled or there is an error.

            _context.next = 25;
            return videoRecognizer.recognize();

          case 25:
            processResult = _context.sent;

            if (!(processResult !== blinkcard_sdk/* RecognizerResultState.Empty */.JY.Empty)) {
              _context.next = 31;
              break;
            }

            _context.next = 29;
            return blinkCardRecognizer.getResult();

          case 29:
            recognitionResult = _context.sent;
            onScanSuccess(recognitionResult);

          case 31:
            // Release browser resources associated with the camera stream
            (_videoRecognizer3 = videoRecognizer) === null || _videoRecognizer3 === void 0 ? void 0 : _videoRecognizer3.releaseVideoFeed(); // // Release memory on WebAssembly heap used by the RecognizerRunner

            recognizerRunner === null || recognizerRunner === void 0 ? void 0 : recognizerRunner["delete"](); // // Release memory on WebAssembly heap used by the recognizer

            blinkCardRecognizer === null || blinkCardRecognizer === void 0 ? void 0 : blinkCardRecognizer["delete"]();
            _context.next = 40;
            break;

          case 36:
            _context.prev = 36;
            _context.t0 = _context["catch"](15);

            if (_context.t0.name === 'VideoRecognizerError') {
              // Reason is of type BlinkCardSDK.NotSupportedReason and contains information why video
              // recognizer could not be used. Usually this happens when user didn't grant access to a
              // camera or when a hardware or OS error occurs.
              reason = _context.t0.details.reason;
              onError(reason);
            }

            if (_context.t0.name === 'NotAllowedError') {
              onError('Camera Access Denied');
            }

          case 40:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[15, 36]]);
  }));
  return _startDebitCardScan.apply(this, arguments);
}
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/features/BlinkCard.tsx



var BlinkCard_templateObject, BlinkCard_templateObject2, BlinkCard_templateObject3, BlinkCard_templateObject4, BlinkCard_templateObject5, BlinkCard_templateObject6, _templateObject7, _templateObject8, _templateObject9;

















var assetBaseUrl =  false ? 0 : '/pay';
var cameraFeedbackText = {
  cardNumber: 'Scan the card number',
  alignCameraToFrame: 'Align the card into frame'
};

function BlinkCard(_ref) {
  var onScanSuccess = _ref.onScanSuccess,
      onDismiss = _ref.onDismiss,
      onError = _ref.onError;
  var mountedRef = (0,react.useRef)(false); // BlinkCard UI Element

  var cameraFeedRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(null),
      blinkCardWasmSdk = _useState[0],
      setBlinkCardWasmSdk = _useState[1];

  var isLoadingSdk = !blinkCardWasmSdk;

  var _useMachine = (0,useMachine/* useMachine */.eO)(cardCaptureMachine),
      _useMachine2 = (0,slicedToArray/* default */.Z)(_useMachine, 2),
      cardCaptureState = _useMachine2[0],
      cardCaptureSend = _useMachine2[1]; // Create a cancel object that we can send to startDebitCardScan
  // so we have access to videoRecognizer


  var _useState2 = (0,react.useState)(null),
      cancelScan = _useState2[0],
      setCancelScan = _useState2[1];

  var handleScanSuccess = (0,react.useCallback)(function (result) {
    onScanSuccess(result);
  }, [onScanSuccess]);

  var handleDismiss = function handleDismiss() {
    cancelScan === null || cancelScan === void 0 ? void 0 : cancelScan.run();

    if (onDismiss) {
      onDismiss();
    }
  };

  var handleError = (0,react.useCallback)(function (errorMessage, errorCode) {
    if (onDismiss) {
      onDismiss();
    }

    if (onError) {
      onError(errorMessage, errorCode);
    }
  }, [onError, onDismiss]); // Track if the component is mounted so that we can stop state updates
  // if the user closes the modal and the SDK loads async.

  (0,react.useLayoutEffect)(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  }, []);
  (0,react.useEffect)(function () {
    if (false) {} // This initializes blinkCard wasm SDk - it runs as a webworker
    // and it only needs to be initialized once.


    if (!blinkCardWasmSdk) {
      var loadSettings = new blinkcard_sdk/* WasmSDKLoadSettings */.zx("sRwAAAYNYXBwLmNoaW1lLmNvbQ8yhfohKyfWlmKpEpdXAqSxmCfvI1HPRXRS1SF6aM0nxVr2EoG+Z4Iiqj3BDoHCkd3i2lGcJbQyKEZ98aIKSiqPmXuxe5jGhnn6JWeu6kmfLO2Qg2o/yG0e5cD0PTGDXPqsEPKsvfs3kBTfGosduzvgdZBKJdMQYuI43Q2lT8Mn2an78FiqJQ==");
      loadSettings.engineLocation = "".concat(window.location.origin).concat(assetBaseUrl, "/blinkCard/resources");
      loadSettings.workerLocation = loadSettings.engineLocation + '/BlinkCardWasmSDK.worker.min.js';
      blinkcard_sdk/* loadWasmModule */.aV(loadSettings).then(function (wasmSDK) {
        if (mountedRef.current) {
          setBlinkCardWasmSdk(wasmSDK);
        }
      }, function (error) {
        // Error happened during the initialization of the SDK
        handleError(error.message, error.code);
      });
    } else if (cardCaptureState.matches('idle')) {
      // Metadata callbacks from microblink SDk
      // @link: https://github.com/blinkcard/blinkcard-in-browser/blob/master/src/MicroblinkSDK/MetadataCallbacks.ts
      var recognizerRunnerCallbacks = {
        onQuadDetection: function onQuadDetection(quad) {
          if (!cameraFeedRef.current) {
            return;
          }

          var detectionStatus = quad.detectionStatus;

          switch (detectionStatus) {
            case blinkcard_sdk/* DetectionStatus.CameraTooHigh */.hD.CameraTooHigh:
            case blinkcard_sdk/* DetectionStatus.CameraTooNear */.hD.CameraTooNear:
            case blinkcard_sdk/* DetectionStatus.DocumentTooCloseToEdge */.hD.DocumentTooCloseToEdge:
            case blinkcard_sdk/* DetectionStatus.Partial */.hD.Partial:
            case blinkcard_sdk/* DetectionStatus.CameraAtAngle */.hD.CameraAtAngle:
              cardCaptureSend('ALIGN_CAMERA');
              break;

            default:
              cardCaptureSend('RESUME');
              break;
          }
        }
      };
      cardCaptureSend('START');
      startDebitCardScan(blinkCardWasmSdk, cameraFeedRef.current, handleScanSuccess, setCancelScan, recognizerRunnerCallbacks, handleError);
    }
  }, [blinkCardWasmSdk, handleScanSuccess, handleError, cardCaptureSend, cancelScan, cardCaptureState]);

  if (false) {}

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BlinkCardLayout, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CloseButtonLayout, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* IconButton */.hU, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* WhiteCloseIcon */.J2, {}),
        onClick: handleDismiss
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CameraFeed, {
      "aria-label": 'camera video feed',
      ref: cameraFeedRef,
      playsInline: true
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlinkCardContentLayout, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CameraFeedbackTextLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
          size: 'standard',
          color: system/* colors.white */.O9.white,
          children: cameraFeedbackText[cardCaptureState.value]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardOverlayLayout, {
        children: isLoadingSdk ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardOverlay, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DebitCardNumberLayout, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* DebitCardNumber */.E9, {})
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EnterManuallyButtonLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* AltButton */.vm, {
          onClick: handleDismiss,
          children: "Enter manually instead"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* MicroBlinkIcon */.Lq, {})]
    })]
  });
}

var CameraFeedbackTextLayout = styled_components_browser_esm/* default.div */.ZP.div(BlinkCard_templateObject || (BlinkCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 1;\n"])));
var EnterManuallyButtonLayout = styled_components_browser_esm/* default.div */.ZP.div(BlinkCard_templateObject2 || (BlinkCard_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 375px;\n  padding: 0 1.5rem;\n  z-index: 1;\n"])));
var CloseButtonLayout = styled_components_browser_esm/* default.div */.ZP.div(BlinkCard_templateObject3 || (BlinkCard_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 1rem;\n  z-index: 1;\n"])));
var CardOverlay = styled_components_browser_esm/* default.div */.ZP.div(BlinkCard_templateObject4 || (BlinkCard_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: ", " 2px solid;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 0 50rem rgba(1, 1, 1, 0.3);\n  height: 100%;\n  max-height: 205px;\n  transition: all 0.3s ease-in 0s;\n  width: 327px;\n"])), system/* colors.white */.O9.white);
var DebitCardNumberLayout = styled_components_browser_esm/* default.div */.ZP.div(BlinkCard_templateObject5 || (BlinkCard_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 3rem;\n"])));
var BlinkCardLayout = (0,styled_components_browser_esm/* default */.ZP)(dialog_esm/* DialogOverlay */.t9)(BlinkCard_templateObject6 || (BlinkCard_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: black;\n  height: 100%;\n  width: 100%;\n"])));
var BlinkCardContentLayout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 900px;\n  position: absolute;\n  inset: 0;\n  align-content: center;\n  display: grid;\n  grid-gap: 2rem;\n  grid-template-rows: repeat(3, min-content);\n  justify-items: center;\n\n  @media (min-height: 290px) and (max-height: 499px) and (orientation: landscape) {\n    padding-top: 8rem;\n    grid-gap: 0.5rem;\n  }\n"])));
var CardOverlayLayout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  height: 230px;\n  position: relative;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n"])));
var CameraFeed = styled_components_browser_esm/* default.video */.ZP.video(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
/* harmony default export */ var features_BlinkCard = (BlinkCard);
// EXTERNAL MODULE: ./src/hooks/useUserContext.tsx
var useUserContext = __webpack_require__(36220);
// EXTERNAL MODULE: ./src/chime-ui/system/media.ts
var media = __webpack_require__(68574);
;// CONCATENATED MODULE: ./src/utils/detectMobileScreen.ts


function detectMobileScreen() {
  var userAgent = window.navigator.userAgent;
  var userAgentMatchResult = userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|BB|IEMobile|Windows Phone|Silk|Opera Mini|Mobile/i); // Not using useMedia() because we are only interested in checking this once

  var isMobileScreenSize = window.matchMedia("(max-width: ".concat(media/* screenSizes.tablet */.f.tablet - 1, "px)")).matches;
  var isMobileScreen = userAgentMatchResult && isMobileScreenSize;
  return !!isMobileScreen;
}

/* harmony default export */ var utils_detectMobileScreen = (detectMobileScreen);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/features/useBlinkCardDialog.tsx












function checkUserBrowserVersionSupport() {
  // For development on the web
  if (false) {}

  var userAgent = window.navigator.userAgent;
  var userAgentMatchResult = userAgent.match(/(iPhone OS|Android)\s(\d.)/i);
  var isOsVersionSupported = false;

  if (userAgentMatchResult) {
    var _userAgentMatchResult = (0,slicedToArray/* default */.Z)(userAgentMatchResult, 3),
        os = _userAgentMatchResult[1],
        osVersion = _userAgentMatchResult[2];

    isOsVersionSupported = os === 'Android' ? Number(osVersion) > 8 : Number(osVersion) > 13;
  }

  return isOsVersionSupported;
}

function useBlinkCardDialog(_ref) {
  var onShow = _ref.onShow,
      onDismiss = _ref.onDismiss,
      onError = _ref.onError;

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId,
      flipperFlags = userData.flipperFlags;
  var isOcrEnabled = flipperFlags.ocrEnabled;
  var isMobileScreen = utils_detectMobileScreen();
  var isBrowserSupported = blinkcard_sdk/* isBrowserSupported */.TY();
  var isOsVersionSupported = checkUserBrowserVersionSupport();
  var isCurrentUserSupported = isBrowserSupported && isOsVersionSupported;

  if (!isCurrentUserSupported) {
    var unsupportedReason = !isBrowserSupported ? 'web assembly support' : 'browser version';
    (0,trackingEvents/* trackOcrNotTriggered */.vf)(publicId, unsupportedReason);
  }

  var isOcrAvailable = isCurrentUserSupported && isOcrEnabled && isMobileScreen;

  var _useState = (0,react.useState)(false),
      isShowing = _useState[0],
      setIsShowing = _useState[1];

  var _useState2 = (0,react.useState)(null),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  (0,react.useEffect)(function () {
    if (isShowing) {
      (0,trackingEvents/* trackOcrTriggered */.bi)(publicId);
    }
  }, [isShowing, publicId]);
  var handleShow = (0,react.useCallback)(function () {
    setIsShowing(true);

    if (typeof onShow === 'function') {
      onShow();
    }
  }, [onShow]);
  var handleDismiss = (0,react.useCallback)(function () {
    setIsShowing(false);

    if (typeof onDismiss === 'function') {
      onDismiss();
    }

    (0,trackingEvents/* trackCTATapped */.u)(types/* ClaimFlowType.pay */.Tz.pay, 'OCR Cancel Button', 'Claim Info Page', 'pay_anyone_ocr_cancel_button', publicId);
  }, [onDismiss, publicId]);
  var handleError = (0,react.useCallback)(function (errorMessage, errorCode) {
    setIsShowing(false);

    if (errorCode === blinkcard_sdk/* ErrorCodes.WORKER_WASM_LOAD_FAILURE */.SM.WORKER_WASM_LOAD_FAILURE) {
      setErrorMessage('Sorry, there was a problem loading your camera');
    } else {
      setErrorMessage(errorMessage);
    }

    if (typeof onError === 'function') {
      onError();
    }

    (0,trackingEvents/* trackOcrRecognizerError */.LR)(publicId, errorMessage);
    main/* datadogRum.addError */.v.addError(new Error('OCR Error'), {
      publicId: publicId,
      reason: errorMessage
    });
  }, [onError, publicId]);

  function Modal(_ref2) {
    var onScanSuccess = _ref2.onScanSuccess;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(features_BlinkCard, {
      onScanSuccess: onScanSuccess,
      onDismiss: handleDismiss,
      onError: handleError
    });
  }

  return {
    Modal: Modal,
    isShowing: isShowing,
    handleShow: handleShow,
    handleDismiss: handleDismiss,
    errorMessage: errorMessage,
    isOcrAvailable: isOcrAvailable
  };
}

/* harmony default export */ var features_useBlinkCardDialog = (useBlinkCardDialog);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/hooks/useSWR.ts
var useSWR = __webpack_require__(12193);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/pollTransactionStatus.ts



var pollTransactionStatus_templateObject;




var PAY_ANYONE_TOKEN_RESPONSE_QUERY_POLLING = (0,lib/* gql */.Ps)(pollTransactionStatus_templateObject || (pollTransactionStatus_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query PayAnyoneByTokenResponsePolling($token: String!) {\n    unauthenticated {\n      p2p {\n        pay_anyone(token: $token) {\n          __typename\n          ... on PayAnyoneWithExternalCard {\n            claim_with_chime\n            pay_friend {\n              id\n              ux_status\n            }\n          }\n          ... on PayAnyoneFetchError {\n            error_id\n            error_header\n            error_body\n          }\n          ... on StepUpRequiredError {\n            title\n            message\n            challenge_context\n          }\n        }\n      }\n    }\n  }\n"])));
var PollingResult;

(function (PollingResult) {
  PollingResult["succeeded"] = "succeeded";
  PollingResult["failed"] = "failed";
  PollingResult["reversed"] = "reversed";
  PollingResult["sent"] = "sent";
  PollingResult["pending"] = "pending";
  PollingResult["canceled"] = "canceled";
  PollingResult["expired"] = "expired";
  PollingResult["step_up_required"] = "step_up_required";
})(PollingResult || (PollingResult = {}));

var startPolling = function startPolling(success, failure, url, getPollingStatus, graphqlData) {
  var timeoutMs = 20000;
  var pollingMs = 500;
  var status;
  var pollMsElapsed = 0;
  var intervalId;

  var pollTransactionStatus = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _ref2, apolloClient, token, useGqlGetAndClaimPayAnyone, _data$unauthenticated, _data$unauthenticated2, _payAnyoneData$pay_fr, _payAnyoneData$pay_fr2, _yield$apolloClient$q, data, errors, payAnyoneData, _result;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _ref2 = graphqlData || {}, apolloClient = _ref2.apolloClient, token = _ref2.token, useGqlGetAndClaimPayAnyone = _ref2.useGqlGetAndClaimPayAnyone;

              if (!(useGqlGetAndClaimPayAnyone && url.includes("/pf/"))) {
                _context.next = 16;
                break;
              }

              _context.next = 5;
              return apolloClient.query({
                query: PAY_ANYONE_TOKEN_RESPONSE_QUERY_POLLING,
                variables: {
                  token: token
                },
                fetchPolicy: 'network-only'
              });

            case 5:
              _yield$apolloClient$q = _context.sent;
              data = _yield$apolloClient$q.data;
              errors = _yield$apolloClient$q.errors;
              payAnyoneData = data === null || data === void 0 ? void 0 : (_data$unauthenticated = data.unauthenticated) === null || _data$unauthenticated === void 0 ? void 0 : (_data$unauthenticated2 = _data$unauthenticated.p2p) === null || _data$unauthenticated2 === void 0 ? void 0 : _data$unauthenticated2.pay_anyone;
              status = payAnyoneData === null || payAnyoneData === void 0 ? void 0 : (_payAnyoneData$pay_fr = payAnyoneData.pay_friend) === null || _payAnyoneData$pay_fr === void 0 ? void 0 : (_payAnyoneData$pay_fr2 = _payAnyoneData$pay_fr.ux_status) === null || _payAnyoneData$pay_fr2 === void 0 ? void 0 : _payAnyoneData$pay_fr2.toLowerCase();

              if (!((payAnyoneData === null || payAnyoneData === void 0 ? void 0 : payAnyoneData.__typename) === 'PayAnyoneFetchError' || (payAnyoneData === null || payAnyoneData === void 0 ? void 0 : payAnyoneData.__typename) === 'StepUpRequiredError')) {
                _context.next = 12;
                break;
              }

              throw payAnyoneData;

            case 12:
              if (!errors) {
                _context.next = 14;
                break;
              }

              throw errors;

            case 14:
              _context.next = 20;
              break;

            case 16:
              _context.next = 18;
              return (0,useSWR/* fetcher */._)(url, {
                method: 'GET'
              });

            case 18:
              _result = _context.sent;
              status = getPollingStatus(_result);

            case 20:
              _context.next = 27;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](0);
              clearInterval(intervalId);

              if (_context.t0.error_id === 'step_up_required_error') {
                failure({
                  error_id: 'step_up_required_error',
                  challenge_context: _context.t0.step_up_challenge_context
                });
              } else {
                failure('Error fetching transaction result');
              }

              return _context.abrupt("return");

            case 27:
              _context.t1 = status;
              _context.next = _context.t1 === PollingResult.succeeded ? 30 : _context.t1 === PollingResult.reversed ? 33 : _context.t1 === PollingResult.pending ? 36 : _context.t1 === PollingResult.expired ? 39 : _context.t1 === undefined ? 42 : 45;
              break;

            case 30:
              clearInterval(intervalId);
              success('Transaction Claimed Successfully');
              return _context.abrupt("break", 47);

            case 33:
              clearInterval(intervalId);
              failure({
                error_id: 'transaction_failed',
                error_header: 'Something went wrong',
                error_body: "We're sorry. Something misfired on our end. Ask your friend to send the money again."
              });
              return _context.abrupt("break", 47);

            case 36:
              clearInterval(intervalId);
              failure({
                error_id: 'transaction_failed_retryable',
                error_header: 'Something went wrong with the details you provided. Try another card'
              });
              return _context.abrupt("break", 47);

            case 39:
              clearInterval(intervalId);
              failure({
                error_id: 'claimed_from_expired_status',
                error_header: 'Dang! Transaction expired.',
                error_body: 'This transaction is no longer available.'
              });
              return _context.abrupt("break", 47);

            case 42:
              clearInterval(intervalId);
              failure('Status is undefined for this transaction');
              return _context.abrupt("break", 47);

            case 45:
              pollMsElapsed += pollingMs;

              if (pollMsElapsed < timeoutMs) {
                intervalId = setTimeout(pollTransactionStatus, pollingMs);
              } else {
                clearInterval(intervalId);

                if (status === PollingResult.sent) {
                  success('Transaction claim is delayed but will most likely succeed');
                } else {
                  failure('Polling Timeout');
                }
              }

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 22]]);
    }));

    return function pollTransactionStatus() {
      return _ref.apply(this, arguments);
    };
  }();

  intervalId = setTimeout(pollTransactionStatus, 0);
};

var pollTransactionStatus = function pollTransactionStatus(url, getPollingStatus, graphqlData) {
  return new Promise(function (resolve, reject) {
    startPolling(resolve, reject, url, getPollingStatus, graphqlData);
  });
};

/* harmony default export */ var ClaimInfo_pollTransactionStatus = (pollTransactionStatus);
// EXTERNAL MODULE: ./node_modules/@1debit/device-intelligence/dist/index.mjs + 5 modules
var device_intelligence_dist = __webpack_require__(36548);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./src/machines/requestStateMachine.ts

var requestStateMachine = (0,Machine/* createMachine */.C)({
  id: 'buttonState',
  initial: 'idle',
  context: {
    errorMessage: null,
    error: null
  },
  states: {
    idle: {
      on: {
        START: 'loading',
        ERROR: {
          target: 'error',
          actions: [(0,actions/* assign */.f0)({
            error: function error(_, event) {
              return event.error;
            },
            errorMessage: function errorMessage(_, event) {
              return event.errorMessage;
            }
          })]
        }
      }
    },
    loading: {
      on: {
        RESUME: 'idle',
        ERROR: {
          target: 'error',
          actions: [(0,actions/* assign */.f0)({
            error: function error(_, event) {
              return event.error;
            },
            errorMessage: function errorMessage(_, event) {
              return event.errorMessage;
            }
          })]
        }
      }
    },
    error: {
      on: {
        START: 'loading',
        RESUME: {
          target: 'idle',
          actions: [(0,actions/* assign */.f0)({
            error: null,
            errorMessage: null
          })]
        }
      }
    }
  }
});
// EXTERNAL MODULE: ./src/hooks/useGQLQuery.ts
var useGQLQuery = __webpack_require__(88425);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/features/greendotIntegration/useEncryptionKeys.ts


var useEncryptionKeys_templateObject;



var EncryptionKeyType;

(function (EncryptionKeyType) {
  EncryptionKeyType["tabapay"] = "tabapay";
  EncryptionKeyType["greenDot"] = "greendot";
})(EncryptionKeyType || (EncryptionKeyType = {}));

var CARD_ENCRYPTION_KEY_QUERY = (0,lib/* gql */.Ps)(useEncryptionKeys_templateObject || (useEncryptionKeys_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query P2pCardEncryptionKeys {\n    unauthenticated {\n      p2p {\n        card_encryption_keys {\n          id\n          type\n          name\n          key\n        }\n      }\n    }\n  }\n"])));

function useEncryptionKeys() {
  var _graphqlData$unauthen, _graphqlData$unauthen2;

  var _useGQLQuery = (0,useGQLQuery/* useGQLQuery */.k)(CARD_ENCRYPTION_KEY_QUERY, {
    fetchPolicy: 'no-cache'
  }),
      graphqlData = _useGQLQuery.data,
      graphqlError = _useGQLQuery.error;

  var keys = graphqlData === null || graphqlData === void 0 ? void 0 : (_graphqlData$unauthen = graphqlData.unauthenticated) === null || _graphqlData$unauthen === void 0 ? void 0 : (_graphqlData$unauthen2 = _graphqlData$unauthen.p2p) === null || _graphqlData$unauthen2 === void 0 ? void 0 : _graphqlData$unauthen2.card_encryption_keys;
  return {
    keys: keys,
    error: graphqlError
  };
}

/* harmony default export */ var greendotIntegration_useEncryptionKeys = (useEncryptionKeys);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/useArkose.tsx



var ARKOSE_RUN_TIMEOUT = 5000;

function useArkose() {
  var _useState = (0,react.useState)(false),
      arkoseComplete = _useState[0],
      setArkoseComplete = _useState[1];

  var _useState2 = (0,react.useState)(false),
      firedArkoseCompleteTrigger = _useState2[0],
      setFiredArkoseCompleteTrigger = _useState2[1];

  (0,react.useEffect)(function () {
    window.setupEnforcement = setupEnforcement;
  });

  var setupEnforcement = function setupEnforcement(enforcementObject) {
    window.Arkose = enforcementObject;
    window.Arkose.setConfig({
      onCompleted: function onCompleted(response) {
        setArkoseComplete(true);

        if (!firedArkoseCompleteTrigger) {
          var event = new window.CustomEvent('arkoseCompleted', {
            detail: {
              arkoseToken: response.token
            }
          });
          window.dispatchEvent(event);
          setFiredArkoseCompleteTrigger(true);
        }
      }
    });
  };

  var runArkoseWithTimeout = function runArkoseWithTimeout(reject) {
    window.Arkose.run();

    function timeoutReject() {
      reject(new Error('arkose time out.'));
    }

    setTimeout(timeoutReject, ARKOSE_RUN_TIMEOUT);
  };

  var runArkose = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                function resolveArkose(arkoseResult) {
                  resolve(arkoseResult.detail.arkoseToken);
                }

                window.addEventListener('arkoseCompleted', resolveArkose);
                runArkoseWithTimeout(reject);
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function runArkose() {
      return _ref.apply(this, arguments);
    };
  }();

  var removeArkose = function removeArkose() {
    var arkoseScript = document.getElementById('arkosescript');

    if (arkoseScript) {
      arkoseScript.remove();
    }
  };

  return {
    arkoseComplete: arkoseComplete,
    runArkose: runArkose,
    removeArkose: removeArkose
  };
}

/* harmony default export */ var ClaimInfo_useArkose = (useArkose);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(42474);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
// EXTERNAL MODULE: ./node_modules/ec-key/src/ec-key.js
var ec_key = __webpack_require__(96122);
var ec_key_default = /*#__PURE__*/__webpack_require__.n(ec_key);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/encryption/generatePublicKey.tsx
function generatePublicKey(key) {
  /**
   * TabaPay and Green Dot require to use a public key to encrypt the card data
   * this should have a specific format before we apply the encryption
   */
  return "-----BEGIN PUBLIC KEY-----\n".concat(key, "\n-----END PUBLIC KEY-----");
}

/* harmony default export */ var encryption_generatePublicKey = (generatePublicKey);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/encryption/encryptCardForGreenDot.ts
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];





function encryptCardForGreenDot(greenDotPublicKey, cardNumber, expDate, cvv) {
  var _expDate$split = expDate.split('/'),
      _expDate$split2 = (0,slicedToArray/* default */.Z)(_expDate$split, 2),
      expiryMonth = _expDate$split2[0],
      last2digitYear = _expDate$split2[1];

  var expiryYear = "20".concat(last2digitYear);
  var debitCardData = JSON.stringify({
    accountNumber: cardNumber,
    expiryMonth: expiryMonth,
    expiryYear: expiryYear,
    cvv: cvv
  }); // Chime generates the shared secret w/ GD's permanent public key and Chime's ephemeral public key
  // Keys are generated using ECDH algorithm (Elliptic Curve Diffie-hellman)

  var chimeKeyPair = getEphemeralKeyPair();
  var chimePublicKey = chimeKeyPair.getPublicKey();
  var sharedSecret = getSharedSecret(chimeKeyPair, greenDotPublicKey);
  var salt = window.crypto.randomUUID();
  var nonSalt = "production";
  var algorithmId = Buffer.from('id-aes256-GCM');
  var aesKey = generateAesKey(sharedSecret, salt, nonSalt, algorithmId);
  var debitCardDataBuffer = Buffer.from(debitCardData);
  return encrypt(salt, debitCardDataBuffer, Buffer.from(aesKey, 'hex'), chimePublicKey);
}

function generateAesKey(sharedSecret, salt, nonSalt, algorithmId) {
  var algorithmIdBuffer = Buffer.alloc(1, 13);
  var nonSaltBuffer = Buffer.from(nonSalt);
  var saltBuffer = Buffer.from(salt);
  var saltHashBuffer = crypto_browserify_default().createHash('sha256').update(saltBuffer).digest();
  var totalLength = algorithmIdBuffer.length + algorithmId.length + nonSaltBuffer.length + saltHashBuffer.length;
  var algorithmSaltBuffer = Buffer.concat([algorithmIdBuffer, algorithmId, nonSaltBuffer, saltHashBuffer], totalLength);
  return concatKDF(sharedSecret, algorithmSaltBuffer);
} // concatKDF concatenates <0001><shared secret><other data>
// then computes the SHA-256 digest
// returns: hex-encoded string of the SHA-256 hash
// based on: https://nvlpubs.nist.gov/nistpubs/Legacy/SP/nistspecialpublication800-56ar.pdf#page=47


function concatKDF(sharedSecret, otherData) {
  var hash = crypto_browserify_default().createHash('sha256');
  hash.update(Buffer.from([0, 0, 0, 1]));
  hash.update(sharedSecret);
  hash.update(otherData);
  return hash.digest('hex');
}

function encrypt(salt, cardData, aesKey, publicKey) {
  var cipher = crypto_browserify_default().createCipheriv('aes-256-gcm', aesKey, Buffer.alloc(16));
  var encrypted = cipher.update(cardData, 'utf8', 'base64');
  encrypted += cipher["final"]('base64');
  var tag = cipher.getAuthTag();
  var ciphertext = encrypted + Buffer.from(tag).toString('base64');
  var publicKeyHash = crypto_browserify_default().createHash('sha256').update(publicKey).digest('base64');
  return {
    salt: salt,
    encrypted_data: {
      data: ciphertext,
      ephemeral_public_key: publicKey.toString('base64'),
      public_key_hash: publicKeyHash,
      ec_version: 'ECv1'
    }
  };
}

function getSharedSecret(chimeKeyPair, greenDotPublicKey) {
  // Add pem headers because the key returned by the backend does not include them
  var greenDotPublicKeyPem = encryption_generatePublicKey(greenDotPublicKey); // Use ec-key to parse the pem file to generate the ECDH public key

  var greenDotECKey = new (ec_key_default())(greenDotPublicKeyPem, 'pem');
  var greenDotPublicKeyBuffer = greenDotECKey.publicCodePoint;
  return chimeKeyPair.computeSecret(greenDotPublicKeyBuffer, null, 'hex');
}

function getEphemeralKeyPair() {
  var curve = 'prime256v1';
  var edchKey = crypto_browserify_default().createECDH(curve);
  edchKey.generateKeys();
  return edchKey;
}

/* harmony default export */ var encryption_encryptCardForGreenDot = (encryptCardForGreenDot);
// EXTERNAL MODULE: ./node_modules/buffer/index.js
var buffer = __webpack_require__(48764);
// EXTERNAL MODULE: ./node_modules/node-forge/lib/index.js
var node_forge_lib = __webpack_require__(22079);
var lib_default = /*#__PURE__*/__webpack_require__.n(node_forge_lib);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/encryption/encryptCardForTabapay.ts





var encryptCardForTabapay = function encryptCardForTabapay(cardNumbers, expDate, cvv, tabapayPublicKey) {
  var pki = (lib_default()).pki,
      util = (lib_default()).util;
  var cardInfo = formatCardInfoToEncrypt(cardNumbers, expDate, cvv);

  try {
    var publicKey = pki.publicKeyFromPem(encryption_generatePublicKey(tabapayPublicKey)); // Tabapay require to encrypt the data with RSA with Transformation of: RSA/ECB/OAEPWithSHA-256AndMGF1Padding
    // node-forge documentation says 'RSA-OAEP' is the same thing as that transformation
    // more info: https://chimebank.atlassian.net/wiki/x/1QBcFQ then search by: Link card

    var toEncrypt = buffer.Buffer.from(cardInfo);
    var encryptedText = publicKey.encrypt(toEncrypt.toString(), 'RSA-OAEP', {
      md: lib_default().md.sha256.create(),
      mgf1: {
        md: lib_default().md.sha256.create()
      }
    }); // We need to encode to Base64 and then we need to encode again with url-safe

    var encryptedBase64 = util.encode64(encryptedText);
    var encryptedASN1 = urlSafeEncode(encryptedBase64);
    return encryptedASN1;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

function formatCardInfoToEncrypt(cardNumbers, expDate, cvv) {
  var numbers = cardNumbers.replace(/\s/g, '');
  var date = formatExpirationDateForEncryption(expDate);
  /**
   TabaPay require the card info format as:
   card numbers | expiration date | cvv
   example : 9481111999999992|209912|231
   */

  return "".concat(numbers, "|").concat(date, "|").concat(cvv);
}

function formatExpirationDateForEncryption(expDate) {
  var _expDate$split = expDate.split('/'),
      _expDate$split2 = (0,slicedToArray/* default */.Z)(_expDate$split, 2),
      month = _expDate$split2[0],
      last2digitYear = _expDate$split2[1];
  /**
   * Tabapay require the expiration date format as: 202012 (full year + month)
   */


  return "20".concat(last2digitYear).concat(month);
}

function urlSafeEncode(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_');
}

/* harmony default export */ var encryption_encryptCardForTabapay = (encryptCardForTabapay);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/encryption/encryptDebitCard.ts




function encryptDebitCard(encryptionKeys, cardNumber, expDate, cvv) {
  return encryptionKeys.map(function (key) {
    if (key.type === EncryptionKeyType.tabapay) {
      return {
        name: key.name,
        key_id: key.id,
        encrypted_card: encryption_encryptCardForTabapay(cardNumber, expDate, cvv, key.key)
      };
    }

    if (key.type === EncryptionKeyType.greenDot) {
      return {
        name: key.name,
        key_id: key.id,
        encrypted_card: encryption_encryptCardForGreenDot(key.key, cardNumber, expDate, cvv)
      };
    }
  });
}

/* harmony default export */ var encryption_encryptDebitCard = (encryptDebitCard);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/encryption/index.ts


// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
;// CONCATENATED MODULE: ./src/hooks/useGQLMutation.ts




function useGqlMutation(mutation) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useMutation = (0,useMutation/* useMutation */.D)(mutation, options),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 2),
      executeMutation = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      data = _useMutation2$.data,
      loading = _useMutation2$.loading,
      error = _useMutation2$.error;

  var execute = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(variables, context) {
      var result;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return executeMutation({
                variables: variables,
                context: context
              });

            case 2:
              result = _context.sent;
              return _context.abrupt("return", result);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function execute(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    execute: execute,
    data: data,
    loading: loading,
    error: error
  };
}
// EXTERNAL MODULE: ./src/utils/device-intelligence/deviceIntelligenceUtils.ts
var deviceIntelligenceUtils = __webpack_require__(53223);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/nudata/useNudata.tsx
function useNuData() {
  var nds = window.ndsapi || (window.ndsapi = {});
  var ndsReadyCallback = window.ndsReadyCallback || (window.ndsReadyCallback = []);
  var nudataNds = '';
  var nuDataStarted = false;

  var requestCall = function requestCall(callback) {
    if (window.ndsReady) {
      callback();
    } else {
      ndsReadyCallback.push(callback);
    }
  };

  var beginBehaviouralMonitoring = function beginBehaviouralMonitoring() {
    if (nuDataStarted) {
      return;
    }

    var callback = function callback() {
      nds.bindNewFields();
    };

    requestCall(callback);
    nuDataStarted = true;
  };

  var stopBehaviouralMonitoring = function stopBehaviouralMonitoring() {
    var callback = function callback() {
      nds.stop();
    };

    saveBehaviouralData();
    requestCall(callback);
    nuDataStarted = false;
  };

  var clearBehaviouralData = function clearBehaviouralData() {
    var callback = function callback() {
      nds.clear();
    };

    requestCall(callback);
  };

  var saveBehaviouralData = function saveBehaviouralData() {
    var ndspmdNode = document.getElementsByName('nds-pmd').item(0);
    var ndspmdValue = ndspmdNode ? ndspmdNode.value : '';

    if (ndspmdValue) {
      nudataNds = ndspmdValue;
    }
  };

  var getBehaviouralData = function getBehaviouralData() {
    return nudataNds;
  };

  var getSessionId = function getSessionId() {
    var _window$ndsapi, _window$ndsapi$config;

    return ((_window$ndsapi = window.ndsapi) === null || _window$ndsapi === void 0 ? void 0 : (_window$ndsapi$config = _window$ndsapi.config) === null || _window$ndsapi$config === void 0 ? void 0 : _window$ndsapi$config.sessionId) || '';
  };

  return {
    beginBehaviouralMonitoring: beginBehaviouralMonitoring,
    clearBehaviouralData: clearBehaviouralData,
    stopBehaviouralMonitoring: stopBehaviouralMonitoring,
    getBehaviouralData: getBehaviouralData,
    getSessionId: getSessionId
  };
}
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/useCreateClaimInfoFormHook.tsx





var useCreateClaimInfoFormHook_excluded = ["cardnumber", "expdate", "csc"];

var useCreateClaimInfoFormHook_templateObject;



function useCreateClaimInfoFormHook_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useCreateClaimInfoFormHook_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useCreateClaimInfoFormHook_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useCreateClaimInfoFormHook_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @typescript-eslint/no-unused-vars */



















var PAY_ANYONE_CLAIM_NOT_SAVED_DEBIT_CARD = (0,lib/* gql */.Ps)(useCreateClaimInfoFormHook_templateObject || (useCreateClaimInfoFormHook_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation PayAnyoneClaimNotSavedDebitResponse($input: ClaimPayAnyoneInput!) {\n    unauthenticated {\n      p2p {\n        claim_pay_anyone(input: $input) {\n          __typename\n          ... on PayAnyoneClaimError {\n            error_id\n            error_body\n            error_header\n          }\n          ... on ClaimPayAnyoneResult {\n            success\n            token\n          }\n        }\n      }\n    }\n  }\n"])));

var logErrorWithToken = function logErrorWithToken(token, publicId, message) {
  var _window$Rollbar;

  var error = new Error(message);

  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  (_window$Rollbar = window.Rollbar).error.apply(_window$Rollbar, [message, {
    token: token,
    publicId: publicId
  }].concat(rest));

  main/* datadogRum.addError */.v.addError(error, useCreateClaimInfoFormHook_objectSpread({
    token: token,
    publicId: publicId
  }, rest));
};

var obfuscatedFieldValue = 'xxxxxxxx';

var getFirstSixDigits = function getFirstSixDigits(cardNumber) {
  var cardNumberNoSpaces = cardNumber.replace(/\s/g, '');
  return cardNumberNoSpaces.length >= 16 ? cardNumberNoSpaces.substring(0, 6) : obfuscatedFieldValue;
};

function useCreateClaimInfoFormHook(postUrl, analyticEventPrefix, onSubmitSuccess, pollingUrl, pollingFunction, setChallengeContext) {
  var _userData$flipperFlag, _userData$flipperFlag2, _requestState$context, _requestState$context2;

  var _getConfig = config_default()(),
      _getConfig$publicRunt = _getConfig.publicRuntimeConfig,
      socureDeviceSdkKey = _getConfig$publicRunt.socureDeviceSdkKey,
      deployEnvironment = _getConfig$publicRunt.deployEnvironment;

  var apolloClient = (0,useApolloClient/* useApolloClient */.x)();

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var router = (0,next_router.useRouter)();

  var _useMachine = (0,useMachine/* useMachine */.eO)(requestStateMachine),
      _useMachine2 = (0,slicedToArray/* default */.Z)(_useMachine, 2),
      requestState = _useMachine2[0],
      requestSend = _useMachine2[1];

  var _useState = (0,react.useState)(null),
      errorId = _useState[0],
      setErrorId = _useState[1];

  var _useState2 = (0,react.useState)(null),
      deviceSessionId = _useState2[0],
      setDeviceSessionId = _useState2[1];

  var _useEncryptionKeys = greendotIntegration_useEncryptionKeys(),
      keys = _useEncryptionKeys.keys,
      encryptionKeysError = _useEncryptionKeys.error;

  var publicId = (userData === null || userData === void 0 ? void 0 : userData.publicId) || null;
  var bank = userData === null || userData === void 0 ? void 0 : userData.bank;
  var useGqlGetAndClaimPayAnyone = userData === null || userData === void 0 ? void 0 : (_userData$flipperFlag = userData.flipperFlags) === null || _userData$flipperFlag === void 0 ? void 0 : (_userData$flipperFlag2 = _userData$flipperFlag.graphqlUsage) === null || _userData$flipperFlag2 === void 0 ? void 0 : _userData$flipperFlag2.useGqlGetAndClaimPayAnyone;
  var token = router.query.token;
  var pageLocation = "".concat(analyticEventPrefix, " Claim Info Page");
  var uniqueIdPrefix = analyticEventPrefix.toLowerCase().replace(/\s/i, '_');
  var not_saved_debit_card = useGqlMutation(PAY_ANYONE_CLAIM_NOT_SAVED_DEBIT_CARD);
  var execute = not_saved_debit_card.execute;

  var _useArkose = ClaimInfo_useArkose(),
      runArkose = _useArkose.runArkose;

  var _useNuData = useNuData(),
      beginBehaviouralMonitoring = _useNuData.beginBehaviouralMonitoring,
      stopBehaviouralMonitoring = _useNuData.stopBehaviouralMonitoring,
      getBehaviouralData = _useNuData.getBehaviouralData,
      getSessionId = _useNuData.getSessionId;

  beginBehaviouralMonitoring();

  if (encryptionKeysError) {
    main/* datadogRum.addError */.v.addError(new Error('Encryption Key Fetch Error'), {
      publicId: publicId,
      message: encryptionKeysError
    });
    requestSend('ERROR');
  }

  (0,react.useEffect)(function () {
    var deviceOptions = {
      publicKey: socureDeviceSdkKey,
      endpoint: 'https://transaction.chime.com/api/ingestion',
      userConsent: true,
      context: 'login'
    };

    if (!window.devicer) {
      logErrorWithToken(token, publicId, 'Socure devicer failed to load.');
      requestSend('ERROR');
    } else {
      try {
        window.devicer.run(deviceOptions, function (response) {
          if (!response) {
            logErrorWithToken(token, publicId, 'Socure devicer did not respond.');
            requestSend('ERROR');
            return;
          }

          if (!response.sessionId) {
            logErrorWithToken(token, publicId, 'Socure devicer did not respond with a sessionId.', response);
            requestSend('ERROR');
            return;
          }

          setDeviceSessionId(response.sessionId);
        });
      } catch (error) {
        logErrorWithToken(token, publicId, 'Socure devicer.run call failed', error);
        requestSend('ERROR');
      }
    }
  }, [publicId, socureDeviceSdkKey, router, token, requestSend]);

  var submitForm = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
      var cardnumber, expdate, csc, data, bin, cardLastFour, arkoseToken, ndsBehaviouralData, ndsSessionId, deviceId, basePostBody, pfPath, _claimData$unauthenti, _claimData$unauthenti2, baseConfig, input, _result, _ref3, claimData, claimError, claimDataResponse;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cardnumber = _ref.cardnumber, expdate = _ref.expdate, csc = _ref.csc, data = (0,objectWithoutProperties/* default */.Z)(_ref, useCreateClaimInfoFormHook_excluded);
              bin = cardnumber.replace(/\s/g, '').slice(0, 6);
              cardLastFour = cardnumber.replace(/\s/g, '').slice(-4);
              _context.prev = 3;
              (0,trackingEvents/* trackCTATapped */.u)(analyticEventPrefix, 'Transfer', pageLocation, "".concat(uniqueIdPrefix, "_card_info_transfer_button"), publicId, null);
              requestSend('START');
              arkoseToken = '';
              _context.prev = 7;
              _context.next = 10;
              return runArkose();

            case 10:
              arkoseToken = _context.sent;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](7);
              main/* datadogRum.addError */.v.addError(_context.t0, {
                token: token,
                publicId: publicId
              });

            case 16:
              stopBehaviouralMonitoring();
              ndsBehaviouralData = getBehaviouralData();
              ndsSessionId = getSessionId();
              deviceId = (0,device_intelligence_dist/* generateDeviceId */.zW)({
                env: (0,deviceIntelligenceUtils/* deviceIntelligenceEnvironment */.a)(deployEnvironment)
              });
              basePostBody = {
                first_name: data.firstName,
                last_name: data.lastName,
                email: data.email,
                zip_code: data.postalCode,
                bin: bin,
                last_four: cardLastFour,
                expiration: formatExpirationDate(expdate),
                device_id: deviceSessionId,
                segment_anonymous_id: (0,trackingEvents/* getAnonymousId */.yQ)(),
                reuse_external_card: data.cardSave,
                arkose_token: arkoseToken,
                nds: ndsBehaviouralData,
                nudata_session_id: ndsSessionId,
                token: token
              };
              pfPath = postUrl === null || postUrl === void 0 ? void 0 : postUrl.includes("/pf/");

              if (!(useGqlGetAndClaimPayAnyone && pfPath)) {
                _context.next = 40;
                break;
              }

              baseConfig = cloneDeep_default()(basePostBody);
              baseConfig === null || baseConfig === void 0 ? true : delete baseConfig.segment_anonymous_id;
              baseConfig === null || baseConfig === void 0 ? true : delete baseConfig.pay_anyone_tokens;
              input = useCreateClaimInfoFormHook_objectSpread(useCreateClaimInfoFormHook_objectSpread({}, baseConfig), {}, {
                encrypted_parts: encryption_encryptDebitCard(keys, cardnumber, expdate, csc)
              });
              _context.next = 29;
              return execute({
                input: input
              }, {
                headers: useCreateClaimInfoFormHook_objectSpread({}, data.challengeResponseContext && {
                  'Chime-Challenge-Context': data.challengeResponseContext
                })
              });

            case 29:
              _result = _context.sent;
              _ref3 = _result || {}, claimData = _ref3.data, claimError = _ref3.errors;
              claimDataResponse = claimData === null || claimData === void 0 ? void 0 : (_claimData$unauthenti = claimData.unauthenticated) === null || _claimData$unauthenti === void 0 ? void 0 : (_claimData$unauthenti2 = _claimData$unauthenti.p2p) === null || _claimData$unauthenti2 === void 0 ? void 0 : _claimData$unauthenti2.claim_pay_anyone;

              if (!((claimDataResponse === null || claimDataResponse === void 0 ? void 0 : claimDataResponse.__typename) === 'PayAnyoneClaimError')) {
                _context.next = 36;
                break;
              }

              throw claimDataResponse;

            case 36:
              if (!claimError) {
                _context.next = 38;
                break;
              }

              throw claimError;

            case 38:
              _context.next = 42;
              break;

            case 40:
              _context.next = 42;
              return (0,useSWR/* fetcher */._)(postUrl, {
                method: 'POST',
                json: useCreateClaimInfoFormHook_objectSpread(useCreateClaimInfoFormHook_objectSpread({}, basePostBody), {}, {
                  encrypted_parts: encryption_encryptDebitCard(keys, cardnumber, expdate, csc)
                }),
                headers: useCreateClaimInfoFormHook_objectSpread({}, data.challengeResponseContext && {
                  'Chime-Challenge-Context': data.challengeResponseContext
                })
              });

            case 42:
              if (!(pollingUrl && pollingFunction)) {
                _context.next = 45;
                break;
              }

              _context.next = 45;
              return ClaimInfo_pollTransactionStatus(pollingUrl, pollingFunction, {
                token: token,
                apolloClient: apolloClient,
                useGqlGetAndClaimPayAnyone: useGqlGetAndClaimPayAnyone
              });

            case 45:
              requestSend('RESUME');
              onSubmitSuccess(useCreateClaimInfoFormHook_objectSpread({
                cardnumber: cardnumber,
                csc: csc,
                expdate: expdate
              }, data));
              _context.next = 65;
              break;

            case 49:
              _context.prev = 49;
              _context.t1 = _context["catch"](3);

              if (!_context.t1.challenge_context) {
                _context.next = 54;
                break;
              }

              setChallengeContext(_context.t1.challenge_context);
              return _context.abrupt("return");

            case 54:
              if (!_context.t1.error_body) {
                _context.next = 58;
                break;
              }

              (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Transfer', _context.t1.error_body, publicId);
              requestSend('ERROR', {
                error: _context.t1
              });
              return _context.abrupt("return");

            case 58:
              if (!_context.t1.error_header) {
                _context.next = 63;
                break;
              }

              (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Transfer', _context.t1.error_header, publicId);
              requestSend('ERROR', {
                errorMessage: _context.t1.error_header
              });
              setErrorId('debit_card_not_eligible');
              return _context.abrupt("return");

            case 63:
              (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Transfer', 'Something went wrong', publicId);
              requestSend('ERROR');

            case 65:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 49], [7, 13]]);
    }));

    return function submitForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var dismissError = function dismissError() {
    requestSend('RESUME');
  };

  var trackCardNumber = (0,trackingEvents/* handleTrackingInputs */.hF)(function (event, publicId) {
    var _event$target;

    var firstSixDigits = getFirstSixDigits((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'Card Number', pageLocation, firstSixDigits, publicId);
  });

  var trackCardNumberOcr = function trackCardNumberOcr(cardNumber) {
    var firstSixDigits = getFirstSixDigits(cardNumber);
    (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'Card Number OCR', pageLocation, firstSixDigits, publicId);
  };

  var trackExpDate = (0,trackingEvents/* handleTrackingInputs */.hF)(function (event, publicId) {
    (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'Expiration Date', pageLocation, obfuscatedFieldValue, publicId);
  });
  var trackCVV = (0,trackingEvents/* handleTrackingInputs */.hF)(function (event, publicId) {
    (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'CVV', pageLocation, obfuscatedFieldValue, publicId);
  });
  var trackZipCode = (0,trackingEvents/* handleTrackingInputs */.hF)(function (event, publicId) {
    (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'Zip Code', pageLocation, event.target.value, publicId);
  });
  var trackFirstName = (0,react.useCallback)(function (event, publicId) {
    var trackingFunction = (0,trackingEvents/* handleTrackingInputs */.hF)(function (event, publicId) {
      (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'First Name', pageLocation, event.target.value, publicId);
    });
    trackingFunction(event, publicId);
  }, [analyticEventPrefix, pageLocation]);
  var trackLastName = (0,react.useCallback)(function (event, publicId) {
    var trackingFunction = (0,trackingEvents/* handleTrackingInputs */.hF)(function (event, publicId) {
      (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'Last Name', pageLocation, event.target.value, publicId);
    });
    trackingFunction(event, publicId);
  }, [analyticEventPrefix, pageLocation]);
  var trackEmail = (0,trackingEvents/* handleTrackingInputs */.hF)(function (event, publicId) {
    (0,trackingEvents/* trackFieldFilled */.Qu)(analyticEventPrefix, 'Email', pageLocation, event.target.value, publicId);
  });

  var trackOnOcrButtonClick = function trackOnOcrButtonClick() {
    (0,trackingEvents/* trackCTATapped */.u)(analyticEventPrefix, 'OCR Camera Button', pageLocation, "".concat(uniqueIdPrefix, "_ocr_camera_button"), publicId);
  };

  var trackOnSuccessfulOcrScan = function trackOnSuccessfulOcrScan(isPartialScan) {
    (0,trackingEvents/* trackSuccessfulOcrScan */.BM)(publicId, isPartialScan);
  };

  var formatExpirationDate = function formatExpirationDate(expDate) {
    var _expDate$split = expDate.split('/'),
        _expDate$split2 = (0,slicedToArray/* default */.Z)(_expDate$split, 2),
        month = _expDate$split2[0],
        last2digitYear = _expDate$split2[1];

    return "".concat(month, "/20").concat(last2digitYear);
  };

  return {
    submitForm: submitForm,
    isLoading: requestState.value === 'loading',
    hasError: requestState.value === 'error',
    errorMessage: (_requestState$context = requestState.context) === null || _requestState$context === void 0 ? void 0 : _requestState$context.errorMessage,
    error: (_requestState$context2 = requestState.context) === null || _requestState$context2 === void 0 ? void 0 : _requestState$context2.error,
    errorId: errorId,
    dismissError: dismissError,
    trackCardNumber: trackCardNumber,
    trackExpDate: trackExpDate,
    trackCVV: trackCVV,
    trackZipCode: trackZipCode,
    trackFirstName: trackFirstName,
    trackLastName: trackLastName,
    trackEmail: trackEmail,
    trackOnSuccessfulOcrScan: trackOnSuccessfulOcrScan,
    trackOnOcrButtonClick: trackOnOcrButtonClick,
    trackCardNumberOcr: trackCardNumberOcr
  };
}

/* harmony default export */ var ClaimInfo_useCreateClaimInfoFormHook = (useCreateClaimInfoFormHook);
// EXTERNAL MODULE: ./node_modules/@xstate/react/es/useService.js + 1 modules
var useService = __webpack_require__(34882);
;// CONCATENATED MODULE: ./src/hooks/useMachineContext.ts


var MachineContext = /*#__PURE__*/(0,react.createContext)(null);
var useMachineContext = function useMachineContext(machineContext) {
  if (!machineContext) {
    throw new Error('useMachineContext requires a valid context object');
  }

  var machineService = (0,react.useContext)(machineContext);

  if (!machineService) {
    throw new Error("useMachineContext should be used with MachineContext.Provider");
  }

  return (0,useService/* useService */.G)(machineService);
};
// EXTERNAL MODULE: ./src/hooks/useTransactionType.tsx
var hooks_useTransactionType = __webpack_require__(38598);
// EXTERNAL MODULE: ./src/types/MoneyRequestStatus.ts
var MoneyRequestStatus = __webpack_require__(14577);
// EXTERNAL MODULE: ./src/types/PayAnyoneStatus.ts
var PayAnyoneStatus = __webpack_require__(87037);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/useClaimInfoBaseForm.tsx












function useClaimInfoBaseForm(setChallengeContext) {
  var _useMachineContext = useMachineContext(MachineContext),
      _useMachineContext2 = (0,slicedToArray/* default */.Z)(_useMachineContext, 2),
      send = _useMachineContext2[1];

  var _useTransactionType = (0,hooks_useTransactionType/* default */.Z)(),
      claimType = _useTransactionType.claimType;

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId;
  var router = (0,next_router.useRouter)();
  var token = router.query.token;
  var postUrl = claimType === types/* ClaimFlowType.pay */.Tz.pay ? "".concat("", "/pf/claim/").concat(router.query.token) : "".concat("", "/mr/pay/").concat(router.query.token);
  var pollingUrl = claimType === types/* ClaimFlowType.pay */.Tz.pay ? "".concat("", "/pf/").concat(token, ".json") : "".concat("", "/mr/").concat(token, ".json?show_step_up=true");
  var pollingFunction = claimType === types/* ClaimFlowType.pay */.Tz.pay ? getPayAnyonePollingStatus : getReceiveFromAnyonePollingStatus;

  var onFormSubmitSuccess = function onFormSubmitSuccess(data) {
    var pageLocation = "".concat(claimType, " Claim Info Page");

    if (claimType === types/* ClaimFlowType.pay */.Tz.pay) {
      (0,trackingEvents/* trackPayAnyoneTermsAccepted */.Gl)(data.terms, pageLocation, publicId);
      (0,trackingEvents/* trackFieldFilled */.Qu)(claimType, 'Pay Anyone Save Debit Card', pageLocation, data.cardSave, publicId);
    }

    if (claimType === types/* ClaimFlowType.receive */.Tz.receive) {
      (0,trackingEvents/* trackReceiveFromAnyoneTermsAccepted */.AP)(data.terms, pageLocation, publicId);
    }

    send('NEXT');
  };

  var _useCreateClaimInfoFo = ClaimInfo_useCreateClaimInfoFormHook(postUrl, claimType, onFormSubmitSuccess, pollingUrl, pollingFunction, setChallengeContext),
      submitForm = _useCreateClaimInfoFo.submitForm,
      hasError = _useCreateClaimInfoFo.hasError,
      errorMessage = _useCreateClaimInfoFo.errorMessage,
      error = _useCreateClaimInfoFo.error,
      errorId = _useCreateClaimInfoFo.errorId,
      isLoading = _useCreateClaimInfoFo.isLoading,
      dismissError = _useCreateClaimInfoFo.dismissError,
      trackCardNumber = _useCreateClaimInfoFo.trackCardNumber,
      trackCVV = _useCreateClaimInfoFo.trackCVV,
      trackExpDate = _useCreateClaimInfoFo.trackExpDate,
      trackZipCode = _useCreateClaimInfoFo.trackZipCode,
      trackFirstName = _useCreateClaimInfoFo.trackFirstName,
      trackLastName = _useCreateClaimInfoFo.trackLastName,
      trackEmail = _useCreateClaimInfoFo.trackEmail,
      trackOnOcrButtonClick = _useCreateClaimInfoFo.trackOnOcrButtonClick,
      trackOnSuccessfulOcrScan = _useCreateClaimInfoFo.trackOnSuccessfulOcrScan,
      trackCardNumberOcr = _useCreateClaimInfoFo.trackCardNumberOcr;

  if (hasError && !errorMessage) {
    if (!error) {
      send('ERROR_PAGE');
    } else {
      send('ERROR_PAGE', error);
    }
  }

  return {
    submitForm: submitForm,
    hasError: hasError,
    errorMessage: errorMessage,
    errorId: errorId,
    isLoading: isLoading,
    dismissError: dismissError,
    trackCardNumber: trackCardNumber,
    trackCVV: trackCVV,
    trackExpDate: trackExpDate,
    trackZipCode: trackZipCode,
    trackFirstName: trackFirstName,
    trackLastName: trackLastName,
    trackEmail: trackEmail,
    trackOnOcrButtonClick: trackOnOcrButtonClick,
    trackOnSuccessfulOcrScan: trackOnSuccessfulOcrScan,
    trackCardNumberOcr: trackCardNumberOcr
  };
}

function getPayAnyonePollingStatus(result) {
  return result === null || result === void 0 ? void 0 : result.status;
}

function getReceiveFromAnyonePollingStatus(result) {
  var moneyRequestStatus = result === null || result === void 0 ? void 0 : result.status;
  var payAnyoneStatus = result === null || result === void 0 ? void 0 : result.payfriendStatus;

  if (moneyRequestStatus === MoneyRequestStatus/* default.pending */.Z.pending && payAnyoneStatus) {
    switch (payAnyoneStatus) {
      case PayAnyoneStatus/* default.succeeded */.Z.succeeded:
        return PollingResult.succeeded;

      case PayAnyoneStatus/* default.pending */.Z.pending:
        return PollingResult.pending;

      case PayAnyoneStatus/* default.sent */.Z.sent:
        return PollingResult.sent;

      case PayAnyoneStatus/* default.failed */.Z.failed:
        return PollingResult.failed;

      case PayAnyoneStatus/* default.step_up_required */.Z.step_up_required:
        return PollingResult.step_up_required;

      default:
        return null;
    }
  }

  switch (moneyRequestStatus) {
    case MoneyRequestStatus/* default.accepted */.Z.accepted:
      return PollingResult.succeeded;

    case MoneyRequestStatus/* default.cancelled */.Z.cancelled:
    case MoneyRequestStatus/* default.expired */.Z.expired:
      return PollingResult.expired;

    case MoneyRequestStatus/* default.pending */.Z.pending:
      return PollingResult.pending;

    default:
      return null;
  }
}

/* harmony default export */ var ClaimInfo_useClaimInfoBaseForm = (useClaimInfoBaseForm);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/utils/nudata/createNudataScript.tsx
function createNudataScript() {
  if (!window.ndsapi) {
    window.ndsapi = {};
  }

  window.ndsReady = false;
  window.ndsReadyCallback = [];
  var nds = window.ndsapi;
  var baseUrl = "https://nd.chime.com/2.2/w/".concat("w-749009", "/sync/js/");
  nds.config = {
    q: [],
    ready: function ready(cb) {
      this.q.push(cb);
    }
  };
  var script = document.createElement('script');
  script.setAttribute('id', 'nudatascript');
  var firstScriptTagOnPage = document.getElementsByTagName('script')[0];
  script.src = baseUrl;
  firstScriptTagOnPage.parentNode.insertBefore(script, firstScriptTagOnPage); // need to set session id and replacement before the nds.load below

  nds.config.ready(function () {
    nds.setSessionId(window.crypto.randomUUID());
    window.ndsReady = true;

    for (var i = 0; i < window.ndsReadyCallback.length; i++) {
      window.ndsReadyCallback.shift()();
    }

    nds.setPlacement('RfaOrPa');
    nds.setPlacementPage(1);
  });

  script.onload = function () {
    nds.load(baseUrl);
  };
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js + 2 modules
var differenceInMonths = __webpack_require__(78356);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 29 modules
var parse = __webpack_require__(62507);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/validation.ts




var nameRegex = /^[ a-zA-Z0-9._-]*$/g;
var emailRegex = /^(([^<>()[\]\\.,;:\s@"']+(\.[^<>()[\]\\.,;:\s@"']+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
var schema = es/* object */.Ry().shape({
  cardnumber: es/* string */.Z_().transform(function (value) {
    return value.replaceAll(' ', '');
  }).min(16, 'Your card should have 16 digits').required('Please enter your card information'),
  expdate: es/* string */.Z_().length(5, 'Please enter a valid expiration date (MM/YY)').matches(/([0-9]{2})\/([0-9]{2})/, 'Please enter a valid expiration date (MM/YY)').required('Please enter your expiration date (MM/YY)').test('invalid date', 'Please enter a valid expiration date (MM/YY)', function (value) {
    var parsedDate = (0,parse/* default */.Z)(value, 'MM/yy', new Date());
    return (0,isValid/* default */.Z)(parsedDate);
  }).test('expired', 'Your card expired. Please add a new one', function (value) {
    var parsedDate = (0,parse/* default */.Z)(value, 'MM/yy', new Date());
    return (0,differenceInMonths/* default */.Z)(new Date(), parsedDate) <= 0;
  }),
  csc: es/* string */.Z_().transform(function (value) {
    return value.substr(0, 3);
  }).length(3, 'Please enter a valid CVV').required('Please enter your CVV'),
  postalCode: es/* string */.Z_().transform(function (value) {
    return value.substr(0, 5);
  }).length(5, 'Please enter a valid ZIP code').required('Please enter your ZIP code'),
  terms: es/* boolean */.O7().oneOf([true]),
  firstName: es/* string */.Z_().min(2, 'Your first name must be at least ${min} characters long').matches(nameRegex, 'Your first name cannot contain special characters').required('Please enter your first name'),
  lastName: es/* string */.Z_().min(2, 'Your last name must be at least ${min} characters long').matches(nameRegex, 'Your last name cannot contain special characters').required('Please enter your last name'),
  email: es/* string */.Z_().matches(emailRegex, 'Please correct your email address').required('Please enter your email')
});
var mobileClaimSchema = schema.omit(['email']);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/ClaimInfoBase.tsx





var ClaimInfoBase_templateObject, ClaimInfoBase_templateObject2, ClaimInfoBase_templateObject3, ClaimInfoBase_templateObject4;

function ClaimInfoBase_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ClaimInfoBase_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ClaimInfoBase_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ClaimInfoBase_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



























var ClaimInfoBase = function ClaimInfoBase(_ref) {
  var _errors$firstName, _errors$lastName, _errors$email;

  var children = _ref.children,
      _ref$hideSaveCardChec = _ref.hideSaveCardCheckbox,
      hideSaveCardCheckbox = _ref$hideSaveCardChec === void 0 ? false : _ref$hideSaveCardChec,
      claimCTACopy = _ref.claimCTACopy,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
    showLogin: true
  }) : _ref$header,
      _ref$formValidationSc = _ref.formValidationSchema,
      formValidationSchema = _ref$formValidationSc === void 0 ? schema : _ref$formValidationSc;

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId;

  var _getConfig = config_default()(),
      deployEnvironment = _getConfig.publicRuntimeConfig.deployEnvironment;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onChange',
    resolver: (0,yup_module/* yupResolver */.X)(formValidationSchema)
  }),
      register = _useForm.register,
      _useForm$formState = _useForm.formState,
      errors = _useForm$formState.errors,
      isValid = _useForm$formState.isValid,
      dirtyFields = _useForm$formState.dirtyFields,
      isSubmitted = _useForm$formState.isSubmitted,
      handleSubmit = _useForm.handleSubmit,
      setFocus = _useForm.setFocus,
      setValue = _useForm.setValue,
      reset = _useForm.reset;

  var resetFormState = function resetFormState() {
    reset();
    showStepUpErrorBottomSheet();
  };

  var STEP_UP_ERROR_MESSAGE = 'Submit the transaction again or try a different debit card.';
  var buildOptions = {
    integrationName: dist/* StepUpIntegrationName.Rfa */.mh.Rfa,
    hideFailureView: false,
    inline: true,
    environment: deployEnvironment === 'production' ? dist/* Environment.Production */.qA.Production : dist/* Environment.NonProduction */.qA.NonProduction,
    onSuccess: function () {
      var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(challengeResponseContext) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return handleSubmit(submitFormHandlerWithChallengeResponseContext(challengeResponseContext))();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSuccess(_x) {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }(),
    onCancel: function onCancel() {
      resetStepUp();
    },
    onFailure: function onFailure() {
      resetFormState();
    },
    onError: function onError() {
      resetFormState();
    }
  };

  var _useStepUp = (0,dist/* useStepUp */.x6)(buildOptions),
      startStepUp = _useStepUp.start,
      challengeProps = _useStepUp.props,
      resetStepUp = _useStepUp.reset;

  var setChallengeContext = function setChallengeContext(challengeRequestContext) {
    startStepUp({
      challengeRequestContext: challengeRequestContext
    });
  };

  var _useBlinkCardDialog = features_useBlinkCardDialog({
    onError: function onError() {
      showErrorDialog();
    }
  }),
      BlinkCardDialog = _useBlinkCardDialog.Modal,
      blinkCardDialogIsShowing = _useBlinkCardDialog.isShowing,
      showBlinkCardDialog = _useBlinkCardDialog.handleShow,
      dismissBlinkCardDialog = _useBlinkCardDialog.handleDismiss,
      blinkCardDialogErrorMessage = _useBlinkCardDialog.errorMessage,
      isOcrAvailable = _useBlinkCardDialog.isOcrAvailable;

  var _useState = (0,react.useState)(isOcrAvailable),
      isCameraButtonShowing = _useState[0],
      setCameraButtonShowing = _useState[1];

  var handleCameraButtonVisibility = function handleCameraButtonVisibility(cardNumber) {
    if (!isOcrAvailable) {
      return;
    } // 19 because card length is 16 + the 3 spaces
    // EX: 4444111199993333 transforms to 4444 1111 9999 3333


    if (cardNumber.length < 19) {
      return setCameraButtonShowing(true);
    }

    setCameraButtonShowing(false);
  };

  var _useClaimInfoBaseForm = ClaimInfo_useClaimInfoBaseForm(setChallengeContext),
      submitForm = _useClaimInfoBaseForm.submitForm,
      hasError = _useClaimInfoBaseForm.hasError,
      errorMessage = _useClaimInfoBaseForm.errorMessage,
      errorId = _useClaimInfoBaseForm.errorId,
      isLoading = _useClaimInfoBaseForm.isLoading,
      dismissError = _useClaimInfoBaseForm.dismissError,
      trackCardNumber = _useClaimInfoBaseForm.trackCardNumber,
      trackCVV = _useClaimInfoBaseForm.trackCVV,
      trackExpDate = _useClaimInfoBaseForm.trackExpDate,
      trackZipCode = _useClaimInfoBaseForm.trackZipCode,
      trackFirstName = _useClaimInfoBaseForm.trackFirstName,
      trackLastName = _useClaimInfoBaseForm.trackLastName,
      trackEmail = _useClaimInfoBaseForm.trackEmail,
      trackOnOcrButtonClick = _useClaimInfoBaseForm.trackOnOcrButtonClick,
      trackOnSuccessfulOcrScan = _useClaimInfoBaseForm.trackOnSuccessfulOcrScan,
      trackCardNumberOcr = _useClaimInfoBaseForm.trackCardNumberOcr;

  var submitFormHandlerWithChallengeResponseContext = (0,react.useCallback)(function (challengeResponseContext) {
    return /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
        var formData;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = data;

                if (challengeResponseContext) {
                  formData.challengeResponseContext = challengeResponseContext;
                }

                _context2.next = 4;
                return submitForm(formData);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  }, [submitForm]);

  var handleOnOcrClick = function handleOnOcrClick() {
    showBlinkCardDialog();
    trackOnOcrButtonClick();
  };

  var _useBottomSheet = (0,components_Modal/* useBottomSheet */.a)(),
      BottomSheet = _useBottomSheet.Modal,
      bottomSheetIsShowing = _useBottomSheet.isShowing,
      showBottomSheet = _useBottomSheet.handleShow,
      dismissBottomSheet = _useBottomSheet.handleDismiss;

  var _useBottomSheet2 = (0,components_Modal/* useBottomSheet */.a)(),
      StepUpErrorBottomSheet = _useBottomSheet2.Modal,
      stepUpErrorBottomSheetIsShowing = _useBottomSheet2.isShowing,
      showStepUpErrorBottomSheet = _useBottomSheet2.handleShow;

  var _useErrorDialog = (0,components_Modal/* useErrorDialog */.I)({
    onDismiss: function onDismiss() {
      dismissError();
    }
  }),
      ErrorDialog = _useErrorDialog.Modal,
      errorDialogIsShowing = _useErrorDialog.isShowing,
      showErrorDialog = _useErrorDialog.handleShow;

  (0,react.useEffect)(function () {
    createNudataScript();
  });
  (0,react.useEffect)(function () {
    if (hasError && errorMessage) showErrorDialog();
  }, [errorMessage, hasError, showErrorDialog]); // Removes Card Number and resets form.
  // Stops card validation upon re-entry of card number

  (0,react.useEffect)(function () {
    if (hasError && errorId === 'debit_card_not_eligible') {
      setFocus('cardnumber');
      reset({
        cardnumber: ''
      }, {
        keepDirty: true,
        keepErrors: true
      });
    }
  }, [hasError, errorId, reset, setFocus]);
  (0,react.useEffect)(function () {
    setFocus('firstName');
  }, [setFocus]);

  var handleDebitCardScan = function handleDebitCardScan(result) {
    var _result$expiryDate, _result$expiryDate2;

    dismissBlinkCardDialog();

    if (!result) {
      return;
    }

    var isPartialScan = !(result !== null && result !== void 0 && result.cardNumber) || !(result !== null && result !== void 0 && result.cvv) || !(result !== null && result !== void 0 && (_result$expiryDate = result.expiryDate) !== null && _result$expiryDate !== void 0 && _result$expiryDate.originalString);
    trackOnSuccessfulOcrScan(isPartialScan);

    if (result !== null && result !== void 0 && result.cardNumber) {
      trackCardNumberOcr(result === null || result === void 0 ? void 0 : result.cardNumber);
    }

    setValue('cardnumber', (result === null || result === void 0 ? void 0 : result.cardNumber) || '', {
      shouldValidate: true,
      shouldDirty: true
    });
    setValue('csc', (result === null || result === void 0 ? void 0 : result.cvv) || '', {
      shouldValidate: true,
      shouldDirty: true
    });
    setValue('expdate', (result === null || result === void 0 ? void 0 : (_result$expiryDate2 = result.expiryDate) === null || _result$expiryDate2 === void 0 ? void 0 : _result$expiryDate2.originalString) || '', {
      shouldValidate: true,
      shouldDirty: true
    });
    setCameraButtonShowing(false);
  };

  var isFormInvalidOrIncomplete = isSubmitted ? !isValid : !dirtyFields.firstName || !dirtyFields.lastName || !dirtyFields.cardnumber || !dirtyFields.expdate || !dirtyFields.csc || !dirtyFields.postalCode || !dirtyFields.terms;
  var isSubmitButtonDisabled = isLoading || isFormInvalidOrIncomplete || !dirtyFields.email;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.ZP, {
    header: header,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StepUpChallengeWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* Challenge */.tv, ClaimInfoBase_objectSpread({}, challengeProps))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* SteppedUpInterfaceWrapper */.eC, ClaimInfoBase_objectSpread(ClaimInfoBase_objectSpread({}, challengeProps), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(submitFormHandlerWithChallengeResponseContext()),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* ContentWrapper */.vs, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* SpacedContent */.DR, {
            children: [children, /*#__PURE__*/(0,jsx_runtime.jsxs)(NameRow, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextField, ClaimInfoBase_objectSpread(ClaimInfoBase_objectSpread({}, register('firstName')), {}, {
                id: 'firstName',
                label: 'First name',
                hasError: !!errors.firstName && isSubmitted,
                onBlur: function onBlur(e) {
                  return trackFirstName(e, publicId);
                },
                onAutoFill: function onAutoFill(e) {
                  return trackFirstName(e, publicId);
                }
              })), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField, ClaimInfoBase_objectSpread(ClaimInfoBase_objectSpread({}, register('lastName')), {}, {
                id: 'lastName',
                label: 'Last name',
                hasError: !!errors.lastName && isSubmitted,
                onBlur: function onBlur(e) {
                  return trackLastName(e, publicId);
                },
                onAutoFill: function onAutoFill(e) {
                  return trackLastName(e, publicId);
                }
              }))]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
              children: !!errors.firstName && isSubmitted && /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_InlineErrorMessage, {
                children: (_errors$firstName = errors.firstName) === null || _errors$firstName === void 0 ? void 0 : _errors$firstName.message
              }, 'firstName')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
              children: !!errors.lastName && isSubmitted && /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_InlineErrorMessage, {
                children: (_errors$lastName = errors.lastName) === null || _errors$lastName === void 0 ? void 0 : _errors$lastName.message
              }, 'lastName')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailRow, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField, ClaimInfoBase_objectSpread(ClaimInfoBase_objectSpread({}, register('email')), {}, {
                id: 'email',
                label: 'Email address',
                autoCapitalize: "none",
                inputMode: "email",
                type: "email",
                hasError: !!errors.email && isSubmitted,
                onBlur: function onBlur(e) {
                  return trackEmail(e, publicId);
                },
                onAutoFill: function onAutoFill(e) {
                  return trackEmail(e, publicId);
                }
              }))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
              children: !!errors.email && isSubmitted && /*#__PURE__*/(0,jsx_runtime.jsx)(TextField_InlineErrorMessage, {
                children: (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
              }, 'email')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimInfo_CardForm, {
              publicId: publicId,
              register: register,
              setValue: setValue,
              errors: errors,
              isSubmitted: isSubmitted,
              trackCVV: trackCVV,
              trackExpDate: trackExpDate,
              trackCardNumber: trackCardNumber,
              trackZipCode: trackZipCode,
              showBottomSheet: showBottomSheet,
              handleOnOcrClick: handleOnOcrClick,
              isCameraButtonShowing: isCameraButtonShowing,
              setCameraButtonShowing: handleCameraButtonVisibility
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckboxLayout, {
              children: [!hideSaveCardCheckbox && /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox, ClaimInfoBase_objectSpread(ClaimInfoBase_objectSpread({}, register('cardSave')), {}, {
                id: 'cardSave',
                defaultChecked: false,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
                  size: 'small',
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
                    bold: true,
                    children: "Use this card for faster cash-outs next time"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\uD83D\uDD12 Your info is always secure and never shared"]
                })
              })), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox, ClaimInfoBase_objectSpread(ClaimInfoBase_objectSpread({}, register('terms')), {}, {
                id: 'terms',
                defaultChecked: false,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
                  size: 'small',
                  children: ["I have read and agree to the Chime", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* UnderlinedBoldGhostButton */.Ni, {
                    as: 'a',
                    href: "https://www.chime.com/policies/chime/pay-friends-non-chime-member-tc",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "Terms and Conditions"
                  }), ' ', "and", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* UnderlinedBoldGhostButton */.Ni, {
                    as: 'a',
                    href: "https://www.chime.com/policies/chime/privacy-policy/",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "Privacy Policy"
                  })]
                })
              }))]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* Button */.zx, {
              "aria-label": 'submit button',
              type: "submit",
              loading: isLoading,
              disabled: isSubmitButtonDisabled,
              children: claimCTACopy
            })]
          })
        })
      })
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: errorDialogIsShowing && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorDialog, {
        children: errorMessage || blinkCardDialogErrorMessage
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: stepUpErrorBottomSheetIsShowing && /*#__PURE__*/(0,jsx_runtime.jsxs)(StepUpErrorBottomSheet, {
        handleDismiss: resetStepUp,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* SmallTitle */.h7, {
          children: "Something went wrong"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
          children: STEP_UP_ERROR_MESSAGE
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: bottomSheetIsShowing && /*#__PURE__*/(0,jsx_runtime.jsxs)(BottomSheet, {
        handleDismiss: dismissBottomSheet,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* SmallTitleSpaced */.Ce, {
          children: "CVV"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* CardBackIcon */.w_, {})]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: blinkCardDialogIsShowing && /*#__PURE__*/(0,jsx_runtime.jsx)(BlinkCardDialog, {
        onScanSuccess: handleDebitCardScan
      })
    })]
  });
};

var NameRow = styled_components_browser_esm/* default.div */.ZP.div(ClaimInfoBase_templateObject || (ClaimInfoBase_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-flow: row wrap;\n  gap: 0.5rem;\n  padding-top: 1rem;\n"])));
var EmailRow = styled_components_browser_esm/* default.div */.ZP.div(ClaimInfoBase_templateObject2 || (ClaimInfoBase_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 0.5rem 0 0 0;\n"])));
var CheckboxLayout = styled_components_browser_esm/* default.div */.ZP.div(ClaimInfoBase_templateObject3 || (ClaimInfoBase_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 1rem;\n"])));
var StepUpChallengeWrapper = styled_components_browser_esm/* default.div */.ZP.div(ClaimInfoBase_templateObject4 || (ClaimInfoBase_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  &:empty {\n    display: none;\n  }\n  padding-top: 30px;\n  padding-bottom: 70px;\n"])));
/* harmony default export */ var ClaimInfo_ClaimInfoBase = (ClaimInfoBase);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/Pay/PayAnyoneClaimInfo.tsx










var PayAnyoneClaimInfo = function PayAnyoneClaimInfo() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var amount = userData.amount,
      publicId = userData.publicId;
  (0,react.useEffect)(function () {
    (0,trackingEvents/* trackPayAnyoneClaimInfoPageViewed */.jE)(publicId);
  }, [publicId]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ClaimInfo_ClaimInfoBase, {
    claimCTACopy: "Claim $".concat(amount),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* SmallTitle */.h7, {
      children: ["Let's get", ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
        bold: true,
        color: colors/* colors.darkGreen */.O9.darkGreen,
        children: ["$", amount]
      }), ' ', "to you"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
      children: "It will be securely added to your bank. We don\u2019t accept prepaid, credit, or international cards."
    })]
  });
};

/* harmony default export */ var Pay_PayAnyoneClaimInfo = (PayAnyoneClaimInfo);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/Request/ReceiveFromAnyoneClaimInfo.tsx











var ReceiveFromAnyoneClaimInfo = function ReceiveFromAnyoneClaimInfo() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var amount = userData.amount,
      name = userData.name,
      publicId = userData.publicId;
  (0,react.useEffect)(function () {
    (0,trackingEvents/* trackReceiveFromAnyoneClaimInfoPageViewed */.Lv)(publicId);
  }, [publicId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimInfo_ClaimInfoBase, {
    hideSaveCardCheckbox: true,
    claimCTACopy: "Pay ".concat(name, " $").concat(amount),
    header: /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
      showLogin: false
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* SmallTitle */.h7, {
      children: ["You're paying ", name, ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
        bold: true,
        color: colors/* colors.darkGreen */.O9.darkGreen,
        children: ["$", amount]
      })]
    })
  });
};

/* harmony default export */ var Request_ReceiveFromAnyoneClaimInfo = (ReceiveFromAnyoneClaimInfo);
;// CONCATENATED MODULE: ./src/components/SubPages/ClaimInfo/index.tsx



// EXTERNAL MODULE: ./src/components/SubPages/Confirmation/index.tsx + 5 modules
var Confirmation = __webpack_require__(43218);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/scroll/use-viewport-scroll.js + 1 modules
var use_viewport_scroll = __webpack_require__(74875);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.js + 4 modules
var use_transform = __webpack_require__(68003);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMedia.js + 1 modules
var useMedia = __webpack_require__(58828);
;// CONCATENATED MODULE: ./src/chime-ui/components/StickyButton/index.tsx




var StickyButton_templateObject, StickyButton_templateObject2, StickyButton_templateObject3, StickyButton_templateObject4;

var StickyButton_excluded = ["children"];

function StickyButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StickyButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StickyButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StickyButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var StickyButton = function StickyButton(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StickyButton_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StickyWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* Button */.zx, StickyButton_objectSpread(StickyButton_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

var StickyWrapper = function StickyWrapper(_ref2) {
  var children = _ref2.children;
  var isTablet = (0,useMedia/* default */.Z)("(min-width: ".concat(media/* screenSizes.tablet */.f.tablet, "px)"));

  var _useViewportScroll = (0,use_viewport_scroll/* useViewportScroll */.M)(),
      scrollY = _useViewportScroll.scrollY;

  var shadowScale = (0,use_transform/* useTransform */.H)(scrollY, [0, 50], ['0px -2px 4px rgba(0, 0, 0, 0)', '0px -2px 4px rgba(0, 0, 0, 0.1)']);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledStickyWrapper, {
    style: {
      boxShadow: isTablet ? 'none' : shadowScale
    },
    children: children
  });
};
var StyledStickyWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(StickyButton_templateObject || (StickyButton_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n\n  ", "\n\n  background-color: ", ";\n  padding: 1.5rem;\n\n  ", "\n"])), media/* default.mobileOnly */.Z.mobileOnly(StickyButton_templateObject2 || (StickyButton_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([" \n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  "]))), media/* default.tinyMobileOnly */.Z.tinyMobileOnly(StickyButton_templateObject3 || (StickyButton_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: initial;\n  "]))), system/* colors.white */.O9.white, media/* default.tablet */.Z.tablet(StickyButton_templateObject4 || (StickyButton_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: 1.5rem 0 2.5rem;\n  "]))));
/* harmony default export */ var components_StickyButton = (StickyButton);
// EXTERNAL MODULE: ./src/components/SubPages/Error/Generic.tsx
var Generic = __webpack_require__(87083);
;// CONCATENATED MODULE: ./src/components/SubPages/Error/Claimed.tsx










var ErrorClaimed = function ErrorClaimed() {
  var _useTransactionType = (0,hooks_useTransactionType/* default */.Z)(),
      claimType = _useTransactionType.claimType;

  var isReceiveTransactionType = claimType === types/* ClaimFlowType.receive */.Tz.receive;

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var referralToken = userData === null || userData === void 0 ? void 0 : userData.referralToken;

  if (isReceiveTransactionType) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Generic/* default */.Z, {
      showLogin: false,
      cta: /*#__PURE__*/(0,jsx_runtime.jsx)(components_StickyButton, {
        as: "a",
        href: "".concat("https://chime.com", "/r/").concat(referralToken),
        children: "Join Chime"
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* SmallTitle */.h7, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
          capitalize: true,
          children: "Payment"
        }), " already made"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
        children: "This payment has already been made."
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Generic/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* SmallTitle */.h7, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
        capitalize: true,
        children: "Payment"
      }), " already claimed"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
      children: "This payment has already been claimed. If this wasn't you, please contact us immediately."
    })]
  });
};

/* harmony default export */ var Claimed = (ErrorClaimed);
;// CONCATENATED MODULE: ./src/components/SubPages/Error/ContextualXState.tsx










function ErrorContextual(_ref) {
  var _context$error;

  var _ref$showLogin = _ref.showLogin,
      showLogin = _ref$showLogin === void 0 ? true : _ref$showLogin,
      _ref$showCta = _ref.showCta,
      showCta = _ref$showCta === void 0 ? true : _ref$showCta;

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var _useMachineContext = useMachineContext(MachineContext),
      _useMachineContext2 = (0,slicedToArray/* default */.Z)(_useMachineContext, 1),
      state = _useMachineContext2[0];

  var context = state.context;
  if (!((_context$error = context.error) !== null && _context$error !== void 0 && _context$error.id)) return /*#__PURE__*/(0,jsx_runtime.jsx)(Generic/* default */.Z, {});

  var CTAComponent = function CTAComponent() {
    return context.error.id === 'claimed_from_expired_status' ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_StickyButton, {
      as: "a",
      href: "".concat("https://chime.com", "/r/").concat(userData.referralToken),
      children: "Join Chime"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_StickyButton, {
      as: "a",
      href: "https://help.chime.com/hc/en-us/articles/23918862092567-How-can-I-troubleshoot-issues-with-claiming-Pay-Anyone-Transfers-if-I-m-not-a-Chime-member",
      children: "Get help"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Generic/* default */.Z, {
    cta: showCta ? /*#__PURE__*/(0,jsx_runtime.jsx)(CTAComponent, {}) : null,
    showLogin: showLogin,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* SmallTitle */.h7, {
      children: context.error.header
    }), context.error.body.split('\n').map(function (text, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
          children: text
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
      }, "error".concat(index));
    })]
  });
}

/* harmony default export */ var ContextualXState = (ErrorContextual);
;// CONCATENATED MODULE: ./src/components/SubPages/Error/Contextual.tsx









function Contextual_ErrorContextual(_ref) {
  var referralToken = _ref.referralToken,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? null : _ref$error;

  var _useTransactionType = useTransactionType(),
      claimType = _useTransactionType.claimType;

  var hideLogin = claimType === ClaimFlowType.receive;
  if (!(error !== null && error !== void 0 && error.error_id)) return /*#__PURE__*/_jsx(ErrorGeneric, {
    showLogin: !hideLogin
  });

  var CTAComponent = function CTAComponent() {
    return error.error_id === 'claimed_from_expired_status' ? /*#__PURE__*/_jsx(Button, {
      as: "a",
      href: "".concat("https://chime.com", "/r/").concat(referralToken),
      children: "Join Chime"
    }) : /*#__PURE__*/_jsx(Button, {
      as: "a",
      href: "https://help.chime.com/hc/en-us/articles/23918862092567-How-can-I-troubleshoot-issues-with-claiming-Pay-Anyone-Transfers-if-I-m-not-a-Chime-member",
      children: "Get help"
    });
  };

  return /*#__PURE__*/_jsxs(ErrorGeneric, {
    showLogin: !hideLogin,
    cta: /*#__PURE__*/_jsx(CTAComponent, {}),
    children: [/*#__PURE__*/_jsx(SmallTitle, {
      children: error.error_header
    }), error.error_body.split('\n').map(function (text, index) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(StandardText, {
          children: text
        }), /*#__PURE__*/_jsx("br", {})]
      }, "error".concat(index));
    })]
  });
}

/* harmony default export */ var Contextual = ((/* unused pure expression or super */ null && (Contextual_ErrorContextual)));
;// CONCATENATED MODULE: ./src/components/SubPages/Error/Expired.tsx








var ErrorExpired = function ErrorExpired(_ref) {
  var referralToken = _ref.referralToken;

  var _useTransactionType = (0,hooks_useTransactionType/* default */.Z)(),
      claimType = _useTransactionType.claimType;

  var isReceiveClaimFlow = claimType === types/* ClaimFlowType.receive */.Tz.receive;

  if (isReceiveClaimFlow) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Generic/* default */.Z, {
      cta: null,
      showLogin: false,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* SmallTitle */.h7, {
        children: "Dang! Transaction expired."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
        children: "This transaction is no longer available."
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Generic/* default */.Z, {
    cta: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* Button */.zx, {
      as: "a",
      href: "".concat("https://chime.com", "/r/").concat(referralToken),
      children: "Join Chime"
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* SmallTitle */.h7, {
      children: "Dang! Payment expired."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
      children: "This payment is no longer available. Ask your friend to send money again."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardText */.nn, {
      children: "You can still join Chime, and you'll get $100 when you set up a qualifying direct deposit of $200+ within 45 days of enrolling."
    })]
  });
};

/* harmony default export */ var Expired = (ErrorExpired);
;// CONCATENATED MODULE: ./src/components/SubPages/Error/index.tsx





;// CONCATENATED MODULE: ./src/components/SubPages/Error/MaintenanceMessage.tsx


var MaintenanceMessage_templateObject;








function MaintenanceMessage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Generic/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentLayout, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
        size: 'small',
        children: "Currently under maintenance"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
        size: 'standard',
        children: "We are working on making your experience better. Please try again later or contact our Member Services team if you need more support."
      })]
    })
  });
}

var ContentLayout = styled_components_browser_esm/* default.div */.ZP.div(MaintenanceMessage_templateObject || (MaintenanceMessage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  row-gap: 0.5rem;\n"])));
/* harmony default export */ var Error_MaintenanceMessage = (MaintenanceMessage);
// EXTERNAL MODULE: ./src/types/ClaimFlowType.ts
var types_ClaimFlowType = __webpack_require__(40912);
// EXTERNAL MODULE: ./src/components/SubPages/Landing/PayFAQText.tsx
var PayFAQText = __webpack_require__(44143);
// EXTERNAL MODULE: ./src/hooks/useBonusAmount.tsx
var useBonusAmount = __webpack_require__(42029);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/RFAFAQText.tsx





var RFAFAQText = function RFAFAQText() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StrongTextSpaced */.SH, {
      children: "What are Pay Anyone Transfers?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "When you receive a text or email about a Pay Anyone Transfer, you can instantly transfer those funds directly to a Chime member fee-free. When you successfully send the Pay Anyone Transfer; the funds are transferred from the bank account associated with the debit card information you provided."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StrongTextSpaced */.SH, {
      children: "Are they really instant?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "Instant transfers can be used to send Pay Anyone Transfers to Chime members 24 hours a day, 365 days a year, regardless of holiday or weekend schedules. However, Pay Anyone Transfers may be affected by circumstances beyond our control (such as fire, flood, power failure, strike, labor dispute, critical service provider failure, computer breakdown, telephone line disruption, government or regulatory action, or a natural disaster), despite reasonable precautions that we have taken."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "Additionally, Pay Anyone Transfers are reviewed and could be declined, delayed, or blocked if the transfer could result in fraud or another form of financial harm. We may request that you provide additional information to verify your identity."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StrongTextSpaced */.SH, {
      children: "What limits are there on sending Pay Anyone Transfers?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "There are daily, weekly, and monthly limits to the number of and the amount of Pay Anyone Transfers you can send."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "Chime members also have limits in the amount and frequency that they can receive Pay Anyone Transfers from non-Chime members."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StrongTextSpaced */.SH, {
      children: "Can I cancel a Pay Anyone Transfer?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "Your Pay Anyone Transfer will only be complete when you tap or click the Pay button. Once you tap or click the Pay button, you will not be able to cancel the transfer. You\u2019ll receive a confirmation email and confirmation in the web page that your funds were sent."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StrongTextSpaced */.SH, {
      children: "How do I know if I have an eligible bank account or debit card?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "You can only send Pay Anyone Transfers with U.S. bank issued debit cards. Credit cards, prepaid cards, and debit cards issued by foreign banks cannot be used to send funds."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* StrongTextSpaced */.SH, {
      children: ["Why did I get an error when I tried to instantly transfer funds from my bank account?", ' ']
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* StandardTextSpaced */.gy, {
      as: "span",
      children: ["Instant transfers can be reviewed and declined for a variety of reasons, including Chime\u2019s automated internal security measures. Here are some common reasons why you might be receiving an error message:", /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Is your name on the card you used?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Did you enter your debit card information correctly?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Is your debit card expired?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Does the ZIP code you entered match the ZIP code on file with your debit card?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Did you enter credit card information?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Did you enter prepaid information?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Did you enter a foreign bank issued debit card information?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Has it been more than 14 days since the Pay Anyone Transfer was sent?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Have you already claimed these funds?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Does this Pay Anyone Transfer place you over a non-member recipient dollar limit?"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "If you continue to receive an error message, try again later or try again using a different card."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "If that doesn\u2019t work, this feature might be unavailable to you, even if you\u2019ve used a debit card for instant transfers successfully in the past."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StrongTextSpaced */.SH, {
      children: "How do I check on the status of an instant transfer?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "After you have successfully provided a valid name, email address, and U.S. bank issued debit card information for the transfer, you will receive a confirmation on the web page and an email letting you know whether the transfer was successful."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* StandardTextSpaced */.gy, {
      children: "You can also check your account transactions or statements to see if your account was debited. If you don\u2019t see the transaction, you should contact the bank that issued the debit card you used. When you contact them, it\u2019s important to explain that the money will appear as an original credit transaction (AFT) or a real-time payment, not a missing ACH/direct deposit."
    })]
  });
};

/* harmony default export */ var Landing_RFAFAQText = (RFAFAQText);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/TermsAndConditions.tsx


var TermsAndConditions_templateObject, TermsAndConditions_templateObject2, TermsAndConditions_templateObject3;















function TermsAndConditions(_ref) {
  var bank = _ref.bank,
      claimFlowType = _ref.claimFlowType,
      _ref$isBonusTextVisib = _ref.isBonusTextVisible,
      isBonusTextVisible = _ref$isBonusTextVisib === void 0 ? true : _ref$isBonusTextVisib,
      onFAQClick = _ref.onFAQClick;

  var _useBonusAmount = (0,useBonusAmount/* useBonusAmount */.O)(),
      bonusAmount = _useBonusAmount.bonusAmount;

  var _useBottomSheet = (0,components_Modal/* useBottomSheet */.a)(),
      FAQModal = _useBottomSheet.Modal,
      faqIsShowing = _useBottomSheet.isShowing,
      dismissFAQModal = _useBottomSheet.handleDismiss,
      showFAQModal = _useBottomSheet.handleShow;

  var handleFAQClick = function handleFAQClick() {
    if (onFAQClick) {
      onFAQClick();
    }

    showFAQModal();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TermsAndConditions_Layout, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextBlockLayout, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
        size: 'small',
        color: colors/* colors.darkGrey */.O9.darkGrey,
        children: [isBonusTextVisible && '* When you join Chime. ', bank === 'bancorp' ? 'Banking services provided by The Bancorp Bank, Member FDIC' : bank === 'stride' ? 'Banking services provided by Stride Bank N.A., Member FDIC' : '', ". Sometimes instant transfers can be delayed. See the", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* UnderlinedBoldGhostButton */.Ni, {
          onClick: handleFAQClick,
          children: "Instant Transfers FAQs"
        }), ' ', "for full details."]
      }), isBonusTextVisible && /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
        size: 'small',
        color: colors/* colors.darkGrey */.O9.darkGrey,
        as: 'div',
        marginBottom: '1rem',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
          children: "\u2020"
        }), "Terms and Conditions: In order to qualify for and receive the $", bonusAmount, " reward for claiming a fee-free transfer with Chime, the following conditions must be met: you must (1) be part of the \u201CClaim with Chime\u201D campaign (the \u201CPromotion\u201D); (2) have received a Pay Anyone transfer from a Chime member; (3) not have previously opened a Chime Checking Account (\u201CAccount\u201D); (4) open the new Account as prompted by this webpage to claim your Pay Anyone transfer; and (5) have activated your physical Chime Visa Debit Card within thirty (30) days of opening an Account. Please note, if you open an Account independently from the prompt on this webpage, you will not be eligible for the reward. Additionally, if you successfully join Chime through this Promotion, you and the referring Chime member will not be eligible to receive rewards from concurrent Chime referral incentive programs, such as the $100 referral incentive promotion, in addition to the $", bonusAmount, ' ', "reward for this Promotion. However, you and the referring member are eligible to participate in subsequent Chime referral incentive programs separate from this Promotion. Pay Anyone transfers expire after fourteen (14) days. If your Pay Anyone transfer expires before you open an Account, you will not be eligible for the reward. The reward will be deposited into your new Checking Account generally within two (2) business days after the above conditions are met. Limit 1 reward per individual. Chime reserves the right to cancel or modify the terms of this reward offer or terminate eligibility at any time with or without prior notice. Credits of $10 or more will be reported on tax form 1099-INT for new members. Banking services are provided by The Bancorp Bank, N.A. or Stride Bank, N.A., Members FDIC."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
        size: 'small',
        color: colors/* colors.darkGrey */.O9.darkGrey,
        as: 'div',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
          children: "1"
        }), " Early access to direct deposit funds depends on the timing of the submission of the payment file from the payer. We generally make these funds available on the day the payment file is received, which may be up to 2 days earlier than the scheduled payment date."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
        size: 'small',
        color: colors/* colors.darkGrey */.O9.darkGrey,
        as: 'div',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
          children: "2"
        }), " Deposits in Chime accounts are FDIC insured through The Bancorp Bank or Stride Bank; Members FDIC."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: faqIsShowing && /*#__PURE__*/(0,jsx_runtime.jsxs)(FAQModal, {
        handleDismiss: dismissFAQModal,
        showX: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalTitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
            size: 'small',
            children: claimFlowType == types_ClaimFlowType/* default.receive */.Z.receive ? 'Pay Anyone: Instant Transfer FAQ For Non-Chime Members Senders' : 'Pay Friends Instant Transfer FAQ For Non-Chime Members'
          })
        }), claimFlowType == types_ClaimFlowType/* default.receive */.Z.receive ? /*#__PURE__*/(0,jsx_runtime.jsx)(Landing_RFAFAQText, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(PayFAQText/* default */.Z, {})]
      })
    })]
  });
}

var TermsAndConditions_Layout = styled_components_browser_esm/* default.div */.ZP.div(TermsAndConditions_templateObject || (TermsAndConditions_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-bottom: 1.5rem;\n"])));
var TextBlockLayout = styled_components_browser_esm/* default.div */.ZP.div(TermsAndConditions_templateObject2 || (TermsAndConditions_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-row-gap: 1rem;\n"])));
var ModalTitle = styled_components_browser_esm/* default.div */.ZP.div(TermsAndConditions_templateObject3 || (TermsAndConditions_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-right: 1.5rem;\n  min-height: 1.75rem;\n  margin-bottom: 0.5rem;\n"])));
/* harmony default export */ var Landing_TermsAndConditions = (TermsAndConditions);
// EXTERNAL MODULE: ./node_modules/@giphy/js-fetch-api/esm/api.js + 9 modules
var api = __webpack_require__(79397);
;// CONCATENATED MODULE: ./src/utils/giphy/useGiphy.tsx




var giphyFetch = new api/* default */.Z("m6pX7gLyWws29xNYCDbuyet0MydnpXEF");

function useGiphy(id) {
  var _useState = (0,react.useState)(),
      gif = _useState[0],
      setGif = _useState[1];

  var _useState2 = (0,react.useState)(),
      giphyApiError = _useState2[0],
      setGiphyApiError = _useState2[1];

  (0,react.useEffect)(function () {
    var fetchGif = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _yield$giphyFetch$gif, data;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return giphyFetch.gif(id);

              case 3:
                _yield$giphyFetch$gif = _context.sent;
                data = _yield$giphyFetch$gif.data;
                setGif(data);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                setGiphyApiError(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function fetchGif() {
        return _ref.apply(this, arguments);
      };
    }();

    if (id) {
      fetchGif();
    }
  }, [id]);
  return {
    gif: gif,
    error: giphyApiError
  };
}

/* harmony default export */ var giphy_useGiphy = (useGiphy);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/useLandingBase.tsx





var useLandingBase = function useLandingBase(pageLocation) {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var memoGifId = userData.memoGifId,
      publicId = userData.publicId;

  var _useGiphy = giphy_useGiphy(memoGifId),
      gif = _useGiphy.gif,
      giphyError = _useGiphy.error;

  var onFAQClick = function onFAQClick() {
    trackFAQClick(publicId, pageLocation);
  };

  return {
    onFAQClick: onFAQClick,
    gif: giphyError ? null : gif
  };
};

var trackFAQClick = function trackFAQClick(publicId, pageLocation) {
  return (0,trackingEvents/* trackCTATapped */.u)('Pay Anyone', 'Instant Transfer FAQs', pageLocation, 'instant_transfer_faqs_cta', publicId);
};

/* harmony default export */ var Landing_useLandingBase = (useLandingBase);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/LandingBase.tsx



var LandingBase_templateObject, LandingBase_templateObject2, LandingBase_templateObject3, LandingBase_templateObject4, LandingBase_templateObject5, LandingBase_templateObject6, LandingBase_templateObject7, LandingBase_templateObject8;

















function LandingBase(_ref) {
  var _gif$images;

  var pageLocation = _ref.pageLocation,
      claimFlowType = _ref.claimFlowType,
      landingTitle = _ref.landingTitle,
      children = _ref.children,
      _ref$showHeaderLogin = _ref.showHeaderLogin,
      showHeaderLogin = _ref$showHeaderLogin === void 0 ? true : _ref$showHeaderLogin;

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var bank = userData.bank,
      memo = userData.memo,
      isClaimWithChimeEnabled = userData.claimWithChime;

  var _useLandingBase = Landing_useLandingBase(pageLocation),
      onFAQClick = _useLandingBase.onFAQClick,
      gif = _useLandingBase.gif;

  var _useBottomSheet = (0,components_Modal/* useBottomSheet */.a)(),
      Modal = _useBottomSheet.Modal,
      isShowing = _useBottomSheet.isShowing,
      handleDismiss = _useBottomSheet.handleDismiss;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.ZP, {
    header: /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
      showLogin: showHeaderLogin,
      showTagline: true
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleLayout, {
      hasMemoGif: !!gif,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PlainTextTitleLayout, {
        children: landingTitle
      }), memo && /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
        children: ["For: ", memo, "!"]
      }), gif && /*#__PURE__*/(0,jsx_runtime.jsx)(GifLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Gif, {
          "aria-label": 'Memo Gif',
          alt: gif === null || gif === void 0 ? void 0 : gif.title,
          src: gif === null || gif === void 0 ? void 0 : (_gif$images = gif.images) === null || _gif$images === void 0 ? void 0 : _gif$images.original.url
        })
      })]
    }), children, /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: isShowing && /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal, {
        handleDismiss: handleDismiss,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingBase_ModalTitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
            size: 'small',
            children: "What's Chime?"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* TextBlock */.al, {
          size: 'standard',
          children: "Chime is a mobile and online bank account with an award-winning app that allows you to manage your banking on the go."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
          size: 'standard',
          children: ["Visit", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* UnderlinedBoldGhostButton */.Ni, {
            as: "a",
            href: "https://chime.com",
            target: "_blank",
            rel: "noreferrer",
            children: "Chime.com"
          })]
        })]
      }, "modal")
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FinePrint, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Landing_TermsAndConditions, {
        bank: bank,
        claimFlowType: claimFlowType,
        onFAQClick: onFAQClick,
        isBonusTextVisible: isClaimWithChimeEnabled
      }), gif && /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* TextBlock */.al, {
        size: 'small',
        color: colors/* colors.darkGrey */.O9.darkGrey,
        children: "Powered by GIPHY"
      })]
    })]
  });
}

var PlainTextTitleLayout = styled_components_browser_esm/* default.div */.ZP.div(LandingBase_templateObject || (LandingBase_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-bottom: 0.5rem;\n"])));
var GifLayout = styled_components_browser_esm/* default.div */.ZP.div(LandingBase_templateObject2 || (LandingBase_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 1rem;\n"])));
var Gif = styled_components_browser_esm/* default.img */.ZP.img(LandingBase_templateObject3 || (LandingBase_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 1rem;\n  max-height: 110px;\n  max-width: 100%;\n\n  ", "\n"])), media/* default.tablet */.Z.tablet(LandingBase_templateObject4 || (LandingBase_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-height: 300px;\n  "]))));
var TitleLayout = styled_components_browser_esm/* default.div */.ZP.div(LandingBase_templateObject5 || (LandingBase_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n  text-align: center;\n  margin: ", ";\n\n  ", "\n"])), function (_ref2) {
  var hasMemoGif = _ref2.hasMemoGif;
  return hasMemoGif ? '70px 0 1.5rem 0' : '70px 0 90px 0';
}, media/* default.mobileOnly */.Z.mobileOnly(LandingBase_templateObject6 || (LandingBase_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin: 3.5rem 0\n    "]))));
var LandingBase_ModalTitle = styled_components_browser_esm/* default.div */.ZP.div(LandingBase_templateObject7 || (LandingBase_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-right: 1.5rem;\n  min-height: 1.75rem;\n  margin-bottom: 0.5rem;\n"])));
var FinePrint = styled_components_browser_esm/* default.div */.ZP.div(LandingBase_templateObject8 || (LandingBase_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 2rem 0 0;\n"])));
/* harmony default export */ var Landing_LandingBase = (LandingBase);
// EXTERNAL MODULE: ./src/hooks/useIntersect.ts
var useIntersect = __webpack_require__(62463);
// EXTERNAL MODULE: ./src/hooks/useValuePropsSegmentEvents.ts
var useValuePropsSegmentEvents = __webpack_require__(9502);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/Pay/PayAnyoneValueProps.tsx



var PayAnyoneValueProps_templateObject, PayAnyoneValueProps_templateObject2, PayAnyoneValueProps_templateObject3, PayAnyoneValueProps_templateObject4, PayAnyoneValueProps_templateObject5, PayAnyoneValueProps_templateObject6, PayAnyoneValueProps_templateObject7, PayAnyoneValueProps_templateObject8, PayAnyoneValueProps_templateObject9;












function PayAnyoneValueProps() {
  var containerRef = (0,react.useRef)(null);

  var _useIntersect = (0,useIntersect/* useIntersect */.U)({
    root: null,
    rootMargin: '0px',
    threshold: [0.5, 0.9]
  }),
      _useIntersect2 = (0,slicedToArray/* default */.Z)(_useIntersect, 2),
      setNode = _useIntersect2[0],
      entry = _useIntersect2[1];

  (0,react.useEffect)(function () {
    setNode(containerRef.current);
  }, [setNode]);
  (0,useValuePropsSegmentEvents/* useValuePropsSegmentEvents */.h)(entry, 'PayAnyone Landing Page');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(P2pValuePropsLayout, {
      ref: containerRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PayAnyonePhoneLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* PayAnyonePhone */.QO, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(P2pTitleLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
          size: 'small',
          children: "Chime lets you cash out instantly fee-free"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBoxLayout, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ListBox, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLayout, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ThreePeopleIcon */.vL, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CenteredBlockText, {
            children: "You can securely send money fee-free to anyone"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBox, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLayout, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ScissorFeesIcon */.GC, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CenteredBlockText, {
            children: "No cash-out fees for you or anyone"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBox, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLayout, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* CalendarIcon */.Qu, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CenteredBlockText, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
              children: ["Get paid up to 2 days early with direct deposit", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
                children: "1"
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBox, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLayout, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* PadLockIcon */.e0, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CenteredBlockText, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
              children: ["Your funds are FDIC-insured up to $250,000 through our bank partners", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
                children: "2"
              })]
            })
          })]
        })]
      })]
    })
  });
}

var P2pValuePropsLayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneValueProps_templateObject || (PayAnyoneValueProps_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 3vh 0 0 0;\n\n  ", "\n\n  ", "\n"])), media/* default.tinyMobileOnly */.Z.tinyMobileOnly(PayAnyoneValueProps_templateObject2 || (PayAnyoneValueProps_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 10vh 0 0 0;\n  "]))), media/* default.desktop */.Z.desktop(PayAnyoneValueProps_templateObject3 || (PayAnyoneValueProps_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 2rem 0 0 0;\n  "]))));
var P2pTitleLayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneValueProps_templateObject4 || (PayAnyoneValueProps_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 2rem 0 1rem 0;\n"])));
var ListBoxLayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneValueProps_templateObject5 || (PayAnyoneValueProps_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 0.5rem;\n"])));
var PayAnyonePhoneLayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneValueProps_templateObject6 || (PayAnyoneValueProps_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 1.5rem;\n"])));
var ListBox = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneValueProps_templateObject7 || (PayAnyoneValueProps_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-column-gap: 1.5rem;\n  align-items: center;\n  grid-template-columns: [first] 80px [line2];\n"])));
var IconLayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneValueProps_templateObject8 || (PayAnyoneValueProps_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 80px;\n  width: 80px;\n  max-width: 80px;\n  grid-column-start: 1;\n"])));
var CenteredBlockText = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneValueProps_templateObject9 || (PayAnyoneValueProps_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-column-start: 2;\n"])));
/* harmony default export */ var Pay_PayAnyoneValueProps = (PayAnyoneValueProps);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/useCreateLandingPageHook.tsx




var ClaimType;

(function (ClaimType) {
  ClaimType["CHIME_ENROLLMENT"] = "chime_enrollment";
  ClaimType["DEBIT_CARD"] = "debit_card";
})(ClaimType || (ClaimType = {}));

function useCreateLandingPageHook(fireCtaTappedEvents, fireLandingPageViewedEvents) {
  var _useMachineContext = useMachineContext(MachineContext),
      _useMachineContext2 = (0,slicedToArray/* default */.Z)(_useMachineContext, 2),
      send = _useMachineContext2[1];

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId;
  (0,react.useEffect)(function () {
    fireLandingPageViewedEvents();
  }, [publicId]); // eslint-disable-line react-hooks/exhaustive-deps

  var fireDefaultCtaButtonEvents = function fireDefaultCtaButtonEvents(claimType) {
    fireCtaTappedEvents(claimType);
  };

  var onCtaClickChime = function onCtaClickChime() {
    fireDefaultCtaButtonEvents(ClaimType.CHIME_ENROLLMENT);
  };

  var onCtaClickDebit = function onCtaClickDebit() {
    fireDefaultCtaButtonEvents(ClaimType.DEBIT_CARD);
    send('NEXT');
  };

  return {
    onCtaClickDebit: onCtaClickDebit,
    onCtaClickChime: onCtaClickChime
  };
}

/* harmony default export */ var Landing_useCreateLandingPageHook = (useCreateLandingPageHook);
// EXTERNAL MODULE: ./src/hooks/useP2PEnrollmentFlow.tsx
var useP2PEnrollmentFlow = __webpack_require__(56785);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/Pay/usePayAnyoneLandingPage.tsx







var usePayAnyoneLandingPage = function usePayAnyoneLandingPage() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId,
      senderId = userData.senderId,
      amount = userData.amount,
      isClaimWithChimeEnabled = userData.claimWithChime;

  var _useP2PEnrollmentFlow = (0,useP2PEnrollmentFlow/* default */.Z)(isClaimWithChimeEnabled, amount),
      activateP2pEnrollmentAndNavigate = _useP2PEnrollmentFlow.activateP2pEnrollmentAndNavigate;

  var _useP2PEnrollmentFlow2 = (0,useP2PEnrollmentFlow/* default */.Z)(false, amount),
      activateP2pEnrollmentAndNavigateToLogin = _useP2PEnrollmentFlow2.activateP2pEnrollmentAndNavigate;

  var navigateToLogin = function navigateToLogin() {
    activateP2pEnrollmentAndNavigateToLogin(function () {
      return fireCtaTappedEvents(ClaimType.DEBIT_CARD);
    });
  };

  var fireLandingPageViewedEvents = function fireLandingPageViewedEvents() {
    (0,trackingEvents/* trackLandingPageViewed */.TG)(amount, publicId, senderId, types/* ClaimFlowType.pay */.Tz.pay);
  };

  var fireCtaTappedEvents = function fireCtaTappedEvents(claimType) {
    return (0,trackingEvents/* trackCTATapped */.u)('Pay Anyone', 'Get $', 'Landing Page', 'get_money_button', publicId, claimType);
  };

  var _useCreateLandingPage = Landing_useCreateLandingPageHook(fireCtaTappedEvents, fireLandingPageViewedEvents),
      onCtaClickDebit = _useCreateLandingPage.onCtaClickDebit,
      onCtaClickChime = _useCreateLandingPage.onCtaClickChime;

  var handleDebitClick = function handleDebitClick() {
    onCtaClickDebit();
  };

  return {
    onCtaClickDebit: handleDebitClick,
    onCtaClickChime: onCtaClickChime,
    navigateToEnrollment: activateP2pEnrollmentAndNavigate,
    navigateToLogin: navigateToLogin
  };
};

/* harmony default export */ var Pay_usePayAnyoneLandingPage = (usePayAnyoneLandingPage);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/Pay/PayAnyoneLanding.tsx



var PayAnyoneLanding_templateObject, PayAnyoneLanding_templateObject2, PayAnyoneLanding_templateObject3, PayAnyoneLanding_templateObject4;

















function PayAnyoneLanding() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var name = userData.name,
      amount = userData.amount,
      isClaimWithChimeEnabled = userData.claimWithChime;

  var _usePayAnyoneLandingP = Pay_usePayAnyoneLandingPage(),
      onCtaClickDebit = _usePayAnyoneLandingP.onCtaClickDebit,
      onCtaClickChime = _usePayAnyoneLandingP.onCtaClickChime,
      navigateToEnrollment = _usePayAnyoneLandingP.navigateToEnrollment;

  var _useBonusAmount = (0,useBonusAmount/* useBonusAmount */.O)(),
      bonusAmount = _useBonusAmount.bonusAmount;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Landing_LandingBase, {
    pageLocation: 'Pay Anyone Landing Page',
    claimFlowType: types/* ClaimFlowType.pay */.Tz.pay,
    landingTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
        size: 'large',
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Title */.Dx, {
        size: 'large',
        children: ["sent you $", amount]
      })]
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransferInfoLayout, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
        size: 'small',
        bold: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* LightningBoltEmoji */.Bz, {}), isClaimWithChimeEnabled ? 'Both are instant*' : 'Instant*', " + fee-free"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CTALayout, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PrimaryButton, {
        onClick: function onClick() {
          return navigateToEnrollment(onCtaClickChime);
        },
        children: ["Sign up - free + $", bonusAmount, " bonus", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
          children: "\u2020"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TertiaryButton, {
        onClick: onCtaClickDebit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
          size: 'standard',
          color: colors/* colors.darkerGreen */.O9.darkerGreen,
          bold: true,
          children: "Claim without signing up"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pay_PayAnyoneValueProps, {})]
  });
}

var CTALayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneLanding_templateObject || (PayAnyoneLanding_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n  bottom: 0;\n"])));
var TertiaryButton = (0,styled_components_browser_esm/* default */.ZP)(components_Button/* GhostButton */.gh)(PayAnyoneLanding_templateObject2 || (PayAnyoneLanding_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 48px;\n"])));
var PrimaryButton = (0,styled_components_browser_esm/* default */.ZP)(components_Button/* StyledButton */.Sn)(PayAnyoneLanding_templateObject3 || (PayAnyoneLanding_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-shadow: 0 4px 12px rgba(51, 51, 51, 0.16);\n  position: relative;\n  height: auto;\n"])));
var TransferInfoLayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneLanding_templateObject4 || (PayAnyoneLanding_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n  margin-bottom: 0.5rem;\n"])));
/* harmony default export */ var Pay_PayAnyoneLanding = (PayAnyoneLanding);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/ReturnUser/ReturnUseLanding.animation.tsx
var hand1Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [50, 0],
    x: [-50, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.6
    }
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 50],
    x: [0, -50],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.8
    }
  }
};
var star1Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [100, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.9
    }
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 100],
    transition: {
      duration: 0.4,
      ease: 'easeInOut',
      delay: 0.8
    }
  }
};
var star2Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [10, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 1
    }
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 30],
    transition: {
      duration: 0.4,
      ease: 'easeInOut',
      delay: 0.7
    }
  }
};
var hand2Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [40, 0],
    x: [-40, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7
    }
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 40],
    x: [0, -40],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.9
    }
  }
};
var hand3Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [40, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.8
    }
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 40],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 1
    }
  }
};
var hand4Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [50, 0],
    x: [50, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7
    }
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 50],
    x: [0, 50],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7
    }
  }
};
var hand5Variants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [50, 0],
    x: [50, 0],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.7
    }
  },
  welcomeExit: {
    opacity: [1, 0],
    y: [0, 50],
    x: [0, 50],
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
      delay: 0.8
    }
  }
};
var welcomeMessageVariants = {
  welcomeExit: {
    opacity: [1, 0],
    transitionEnd: {
      display: 'none'
    },
    transition: {
      delay: 1,
      duration: 0.5
    }
  }
};
var welcomeTitleVariants = {
  welcomeEnter: {
    opacity: [0, 1],
    y: [100, 0],
    transition: {
      duration: 0.8,
      ease: 'easeInOut'
    }
  }
};
var landingVariants = {
  welcomeEnter: {
    opacity: 0,
    transition: {
      duration: 0
    }
  },
  welcomeExit: {
    opacity: 0,
    transition: {
      duration: 0
    }
  },
  landingEnter: {
    opacity: [0, 1],
    y: [100, 0],
    transition: {
      duration: 0.8,
      ease: 'easeInOut'
    }
  }
};
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/ReturnUser/useReturnUserLanding.tsx





var useReturnUserLanding_templateObject;

function useReturnUserLanding_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useReturnUserLanding_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useReturnUserLanding_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useReturnUserLanding_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* eslint-disable @typescript-eslint/no-unused-vars */


















var PAY_ANYONE_CLAIM_SAVED_DEBIT_CARD = (0,lib/* gql */.Ps)(useReturnUserLanding_templateObject || (useReturnUserLanding_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation PayAnyoneClaimSavedDebitResponse(\n    $input: ClaimPayAnyoneWithSavedDebitCardInput!\n  ) {\n    unauthenticated {\n      p2p {\n        claim_pay_anyone_with_saved_debit_card(input: $input) {\n          __typename\n          ... on PayAnyoneClaimError {\n            error_id\n            error_body\n            error_header\n          }\n          ... on ClaimPayAnyoneResult {\n            success\n            token\n          }\n        }\n      }\n    }\n  }\n"])));

function useReturnUserLanding(amount, senderId) {
  var _userData$flipperFlag, _userData$flipperFlag2, _requestState$context;

  var _getConfig = config_default()(),
      _getConfig$publicRunt = _getConfig.publicRuntimeConfig,
      socureDeviceSdkKey = _getConfig$publicRunt.socureDeviceSdkKey,
      deployEnvironment = _getConfig$publicRunt.deployEnvironment;

  var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  var router = (0,next_router.useRouter)();

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var _useMachineContext = useMachineContext(MachineContext),
      _useMachineContext2 = (0,slicedToArray/* default */.Z)(_useMachineContext, 2),
      state = _useMachineContext2[0],
      send = _useMachineContext2[1];

  var _useMachine = (0,useMachine/* useMachine */.eO)(requestStateMachine),
      _useMachine2 = (0,slicedToArray/* default */.Z)(_useMachine, 2),
      requestState = _useMachine2[0],
      requestSend = _useMachine2[1];

  var context = state.context;
  var publicId = context.publicId,
      token = context.token;

  var _useState = (0,react.useState)(null),
      deviceSessionId = _useState[0],
      setDeviceSessionId = _useState[1];

  var useGqlGetAndClaimPayAnyone = userData === null || userData === void 0 ? void 0 : (_userData$flipperFlag = userData.flipperFlags) === null || _userData$flipperFlag === void 0 ? void 0 : (_userData$flipperFlag2 = _userData$flipperFlag.graphqlUsage) === null || _userData$flipperFlag2 === void 0 ? void 0 : _userData$flipperFlag2.useGqlGetAndClaimPayAnyone;
  var saved_debit_card_graphql = useGqlMutation(PAY_ANYONE_CLAIM_SAVED_DEBIT_CARD);

  var _ref = saved_debit_card_graphql || {},
      execute = _ref.execute;

  var _useArkose = ClaimInfo_useArkose(),
      runArkose = _useArkose.runArkose;

  var _useNuData = useNuData(),
      beginBehaviouralMonitoring = _useNuData.beginBehaviouralMonitoring,
      stopBehaviouralMonitoring = _useNuData.stopBehaviouralMonitoring,
      getBehaviouralData = _useNuData.getBehaviouralData,
      getSessionId = _useNuData.getSessionId;

  beginBehaviouralMonitoring();
  (0,react.useEffect)(function () {
    (0,trackingEvents/* trackReturnUserPageViewed */.Pr)(amount, publicId, senderId);
  }, [amount, publicId, senderId]);
  (0,react.useEffect)(function () {
    var deviceOptions = {
      publicKey: socureDeviceSdkKey,
      endpoint: 'https://transaction.chime.com/api/ingestion',
      userConsent: true,
      context: 'login'
    };

    if (!window.devicer) {
      useReturnUserLanding_logErrorWithToken(token, publicId, 'Socure devicer failed to load.');
      send('ERROR_PAGE');
    } else {
      try {
        window.devicer.run(deviceOptions, function (response) {
          if (!response) {
            useReturnUserLanding_logErrorWithToken(token, publicId, 'Socure devicer did not respond.');
            send('ERROR_PAGE');
            return;
          }

          if (!response.sessionId) {
            useReturnUserLanding_logErrorWithToken(token, publicId, 'Socure devicer did not respond with a sessionId.', response);
            send('ERROR_PAGE');
            return;
          }

          setDeviceSessionId(response.sessionId);
        });
      } catch (e) {
        useReturnUserLanding_logErrorWithToken(token, publicId, 'Socure devicer.run call failed', e);
        send('ERROR_PAGE');
      }
    }
  }, [context, publicId, send, socureDeviceSdkKey, token, router]);

  var submitDebitClaim = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(lastFour, externalCardId) {
      var postUrl, pollingUrl, pollingFunction, arkoseToken, ndsBehaviouralData, ndsSessionId, deviceId, pfPath, _claimData$unauthenti, _claimData$unauthenti2, result, _ref3, claimData, claimError, claimDataResponse;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              postUrl = "".concat("", "/pf/claim/").concat(token);
              pollingUrl = "".concat("", "/pf/").concat(token, ".json");

              pollingFunction = function pollingFunction(result) {
                return result.status;
              };

              arkoseToken = '';
              _context.prev = 4;
              _context.next = 7;
              return runArkose();

            case 7:
              arkoseToken = _context.sent;
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4);
              main/* datadogRum.addError */.v.addError(_context.t0, {
                token: token,
                publicId: publicId
              });

            case 13:
              stopBehaviouralMonitoring();
              ndsBehaviouralData = getBehaviouralData();
              ndsSessionId = getSessionId();
              deviceId = (0,device_intelligence_dist/* generateDeviceId */.zW)({
                env: (0,deviceIntelligenceUtils/* deviceIntelligenceEnvironment */.a)(deployEnvironment)
              });
              _context.prev = 17;
              requestSend('START');
              pfPath = postUrl === null || postUrl === void 0 ? void 0 : postUrl.includes("/pf/");

              if (!(useGqlGetAndClaimPayAnyone && pfPath)) {
                _context.next = 34;
                break;
              }

              _context.next = 23;
              return execute({
                input: {
                  last_four: lastFour,
                  external_card_id: externalCardId,
                  device_id: deviceSessionId,
                  arkose_token: arkoseToken,
                  nds: ndsBehaviouralData,
                  nudata_session_id: ndsSessionId,
                  token: token
                }
              });

            case 23:
              result = _context.sent;
              _ref3 = result || {}, claimData = _ref3.data, claimError = _ref3.errors;
              claimDataResponse = claimData === null || claimData === void 0 ? void 0 : (_claimData$unauthenti = claimData.unauthenticated) === null || _claimData$unauthenti === void 0 ? void 0 : (_claimData$unauthenti2 = _claimData$unauthenti.p2p) === null || _claimData$unauthenti2 === void 0 ? void 0 : _claimData$unauthenti2.claim_pay_anyone_with_saved_debit_card;

              if (!((claimDataResponse === null || claimDataResponse === void 0 ? void 0 : claimDataResponse.__typename) === 'PayAnyoneClaimError')) {
                _context.next = 30;
                break;
              }

              throw claimDataResponse;

            case 30:
              if (!claimError) {
                _context.next = 32;
                break;
              }

              throw claimError;

            case 32:
              _context.next = 36;
              break;

            case 34:
              _context.next = 36;
              return (0,useSWR/* fetcher */._)(postUrl, {
                method: 'POST',
                json: {
                  last_four: lastFour,
                  external_card_id: externalCardId,
                  device_id: deviceSessionId,
                  arkose_token: arkoseToken,
                  nds: ndsBehaviouralData,
                  nudata_session_id: ndsSessionId
                }
              });

            case 36:
              _context.next = 38;
              return ClaimInfo_pollTransactionStatus(pollingUrl, pollingFunction, {
                token: token,
                apolloClient: apolloClient,
                useGqlGetAndClaimPayAnyone: useGqlGetAndClaimPayAnyone
              });

            case 38:
              requestSend('RESUME');
              send('NEXT');
              _context.next = 56;
              break;

            case 42:
              _context.prev = 42;
              _context.t1 = _context["catch"](17);

              if (!_context.t1.error_body) {
                _context.next = 49;
                break;
              }

              (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Transfer', _context.t1.error_body, publicId);
              send('ERROR_PAGE', _context.t1);
              requestSend('RESUME');
              return _context.abrupt("return");

            case 49:
              if (!_context.t1.error_header) {
                _context.next = 53;
                break;
              }

              (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Transfer', _context.t1.error_header, publicId);
              requestSend('ERROR', {
                errorMessage: _context.t1.error_header
              });
              return _context.abrupt("return");

            case 53:
              (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Transfer', 'Something went wrong', publicId);
              send('ERROR_PAGE');
              requestSend('RESUME');

            case 56:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 10], [17, 42]]);
    }));

    return function submitDebitClaim(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var fireDefaultCtaButtonEvents = function fireDefaultCtaButtonEvents(claimType) {
    trackClaimClick(publicId, claimType);
  };

  var onCtaClickChime = function onCtaClickChime() {
    fireDefaultCtaButtonEvents(ClaimType.CHIME_ENROLLMENT);
  };

  var onCtaClickReuseDebit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(lastFour, externalCardId) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              fireDefaultCtaButtonEvents(ClaimType.DEBIT_CARD);
              _context2.next = 3;
              return submitDebitClaim(lastFour, externalCardId);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onCtaClickReuseDebit(_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onChangeCard = function onChangeCard() {
    trackOnChangeCardClick(publicId);
    send('CHANGE_CARD');
  };

  var dismissError = function dismissError() {
    requestSend('RESUME');
  };

  return {
    onChangeCard: onChangeCard,
    onCtaClickChime: onCtaClickChime,
    onCtaClickReuseDebit: onCtaClickReuseDebit,
    isLoading: requestState.value === 'loading',
    errorMessage: (_requestState$context = requestState.context) === null || _requestState$context === void 0 ? void 0 : _requestState$context.errorMessage,
    dismissError: dismissError
  };
}

var useReturnUserLanding_logErrorWithToken = function logErrorWithToken(token, publicId, message) {
  var _window$Rollbar;

  var error = new Error(message);

  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  (_window$Rollbar = window.Rollbar).error.apply(_window$Rollbar, [message, {
    token: token,
    publicId: publicId
  }].concat(rest));

  main/* datadogRum.addError */.v.addError(error, useReturnUserLanding_objectSpread({
    token: token,
    publicId: publicId
  }, rest));
};

var trackOnChangeCardClick = function trackOnChangeCardClick(publicId) {
  return (0,trackingEvents/* trackCTATapped */.u)('Pay Anyone', 'Need to change debit card?', 'Return User Page', 'pay_anyone_change_debit_card_button', publicId, null);
};

var trackClaimClick = function trackClaimClick(publicId, claimType) {
  return (0,trackingEvents/* trackCTATapped */.u)('Pay Anyone', 'Get $', 'Return User Page', 'get_money_button', publicId, claimType);
};

/* harmony default export */ var ReturnUser_useReturnUserLanding = (useReturnUserLanding);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/ReturnUser/WelcomeMessage.tsx


var WelcomeMessage_templateObject, WelcomeMessage_templateObject2, WelcomeMessage_templateObject3, WelcomeMessage_templateObject4, WelcomeMessage_templateObject5, WelcomeMessage_templateObject6, WelcomeMessage_templateObject7, WelcomeMessage_templateObject8, WelcomeMessage_templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;












function WelcomeMessage(_ref) {
  var animationControls = _ref.animationControls,
      firstName = _ref.firstName;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WelcomeMessageLayout, {
    animate: animationControls,
    variants: welcomeMessageVariants,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(WelcomeMessageContentLayout, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(WelcomeMessage_TitleLayout, {
        animate: animationControls,
        variants: welcomeTitleVariants,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
          size: 'medium',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            role: 'img',
            "aria-label": 'money-mouth face',
            children: "\uD83D\uDC40"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
          size: 'medium',
          children: "Look Everyone!"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Title */.Dx, {
          size: 'medium',
          children: [firstName, " is Back!"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Star1Layout, {
        animate: animationControls,
        variants: star1Variants,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: 'star 1',
          src: "".concat(Icons/* iconsPath */.VA, "star 1.svg")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Star2Layout, {
        animate: animationControls,
        variants: star2Variants,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: 'star 2',
          src: "".concat(Icons/* iconsPath */.VA, "star 2.svg")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hand1Layout, {
        animate: animationControls,
        variants: hand1Variants,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: 'Hand 1',
          src: "".concat(Icons/* iconsPath */.VA, "hand 1.svg")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hand2Layout, {
        animate: animationControls,
        variants: hand2Variants,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: 'Hand 2',
          src: "".concat(Icons/* iconsPath */.VA, "hand 2.svg")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hand3Layout, {
        animate: animationControls,
        variants: hand3Variants,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: 'Hand 3',
          src: "".concat(Icons/* iconsPath */.VA, "hand 3.svg")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hand5Layout, {
        animate: animationControls,
        variants: hand5Variants,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: 'Hand 5',
          src: "".concat(Icons/* iconsPath */.VA, "hand 5.svg")
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hand4Layout, {
        animate: animationControls,
        variants: hand4Variants,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: 'Hand 4',
          src: "".concat(Icons/* iconsPath */.VA, "hand 4.svg")
        })
      })]
    })
  });
}

var WelcomeMessageContentLayout = styled_components_browser_esm/* default.div */.ZP.div(WelcomeMessage_templateObject || (WelcomeMessage_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  z-index: 1;\n  max-width: 37.5rem;\n  height: 100%;\n  padding-top: 4rem;\n  position: relative;\n  margin: 0 auto;\n  overflow: hidden;\n  background-color: ", ";\n\n  ", ";\n"])), colors/* colors.chimeYellow */.O9.chimeYellow, media/* default.tablet */.Z.tablet(WelcomeMessage_templateObject2 || (WelcomeMessage_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 37rem;\n    border-radius: 24px;\n    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.08), 0 24px 32px 0 rgba(0, 0, 0, 0.04);\n  "]))));
var Star1Layout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(WelcomeMessage_templateObject3 || (WelcomeMessage_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 20rem;\n  left: 7rem;\n\n  ", ";\n"])), media/* default.tablet */.Z.tablet(WelcomeMessage_templateObject4 || (WelcomeMessage_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    bottom: 20rem;\n    left: 14rem;\n  "]))));
var Star2Layout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(WelcomeMessage_templateObject5 || (WelcomeMessage_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 17rem;\n  right: 5rem;\n\n  ", ";\n"])), media/* default.tablet */.Z.tablet(WelcomeMessage_templateObject6 || (WelcomeMessage_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n    bottom: 16rem;\n    right: 13rem;\n  "]))));
var Hand1Layout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(WelcomeMessage_templateObject7 || (WelcomeMessage_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 4rem;\n  left: -16rem;\n\n  ", ";\n"])), media/* default.tablet */.Z.tablet(WelcomeMessage_templateObject8 || (WelcomeMessage_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    bottom: 3rem;\n    left: -9rem;\n  "]))));
var Hand2Layout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(WelcomeMessage_templateObject9 || (WelcomeMessage_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: -6rem;\n  left: -7rem;\n\n  ", ";\n"])), media/* default.tablet */.Z.tablet(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    bottom: -7rem;\n    left: -1rem;\n  "]))));
var Hand3Layout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: -9rem;\n  right: 0;\n\n  ", "\n"])), media/* default.tablet */.Z.tablet(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    right: 7rem;\n  "]))));
var Hand4Layout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: -10rem;\n  right: -10rem;\n\n  ", ";\n"])), media/* default.tablet */.Z.tablet(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    bottom: -9rem;\n    right: -3rem;\n  "]))));
var Hand5Layout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 2rem;\n  right: -15rem;\n\n  ", ";\n"])), media/* default.tablet */.Z.tablet(_templateObject16 || (_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n    bottom: 2rem;\n    right: -8rem;\n  "]))));
var WelcomeMessageLayout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(_templateObject17 || (_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: ", ";\n\n  ", "\n"])), colors/* colors.lightYellow */.O9.lightYellow, media/* default.tablet */.Z.tablet(_templateObject18 || (_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-top: 65px;\n  "]))));
var WelcomeMessage_TitleLayout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(_templateObject19 || (_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"])));
/* harmony default export */ var ReturnUser_WelcomeMessage = (WelcomeMessage);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/ReturnUser/ReturnUserLanding.tsx




var ReturnUserLanding_templateObject, ReturnUserLanding_templateObject2, ReturnUserLanding_templateObject3, ReturnUserLanding_templateObject4, ReturnUserLanding_templateObject5;























function ReturnUserLanding() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var name = userData.name,
      amount = userData.amount,
      isClaimWithChimeEnabled = userData.claimWithChime,
      senderId = userData.senderId,
      previousClaim = userData.previousClaim;

  var _useBonusAmount = (0,useBonusAmount/* useBonusAmount */.O)(),
      bonusAmount = _useBonusAmount.bonusAmount;

  var _useReturnUserLanding = ReturnUser_useReturnUserLanding(amount, senderId),
      onChangeCard = _useReturnUserLanding.onChangeCard,
      onCtaClickReuseDebit = _useReturnUserLanding.onCtaClickReuseDebit,
      onCtaClickChime = _useReturnUserLanding.onCtaClickChime,
      isLoading = _useReturnUserLanding.isLoading,
      errorMessage = _useReturnUserLanding.errorMessage,
      dismissError = _useReturnUserLanding.dismissError;

  var _useErrorDialog = (0,components_Modal/* useErrorDialog */.I)({
    onDismiss: function onDismiss() {
      return dismissError();
    }
  }),
      ErrorDialog = _useErrorDialog.Modal,
      errorDialogIsShowing = _useErrorDialog.isShowing,
      showErrorDialog = _useErrorDialog.handleShow;

  (0,react.useEffect)(function () {
    if (errorMessage) {
      showErrorDialog();
    }
  }, [errorMessage, showErrorDialog]);
  (0,react.useEffect)(function () {
    createNudataScript();
  }, []);

  var _useP2PEnrollmentFlow = (0,useP2PEnrollmentFlow/* default */.Z)(isClaimWithChimeEnabled, amount),
      activateP2pEnrollmentAndNavigate = _useP2PEnrollmentFlow.activateP2pEnrollmentAndNavigate;

  var animationControls = (0,use_animation/* useAnimation */._)();
  (0,react.useEffect)(function () {
    var startAnimation = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return animationControls.start('welcomeEnter');

              case 2:
                _context.next = 4;
                return animationControls.start('welcomeExit');

              case 4:
                _context.next = 6;
                return animationControls.start('landingEnter');

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function startAnimation() {
        return _ref.apply(this, arguments);
      };
    }();

    startAnimation();
  }, [animationControls]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReturnUser_WelcomeMessage, {
      animationControls: animationControls,
      firstName: previousClaim.firstName
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(motion_minimal.m.div, {
      animate: animationControls,
      variants: landingVariants,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Landing_LandingBase, {
        pageLocation: 'Return User Page',
        claimFlowType: types/* ClaimFlowType.pay */.Tz.pay,
        landingTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
            size: 'large',
            children: name
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Title */.Dx, {
            size: 'large',
            children: ["sent you $", amount]
          })]
        }),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GreetingLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
            size: 'small',
            bold: true,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              role: 'img',
              "aria-label": 'lightning bolt',
              children: "\uD83C\uDF89"
            }), ' ', "It\u2019s good to see you again"]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReturnUserLanding_CTALayout, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ReturnUserLanding_PrimaryButton, {
            onClick: function onClick() {
              return activateP2pEnrollmentAndNavigate(onCtaClickChime);
            },
            children: ["Cash out with Chime", isClaimWithChimeEnabled && " + $".concat(bonusAmount, " bonus"), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
              children: "\u2020"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
            onSubmit: function onSubmit(e) {
              return e.preventDefault();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SecondaryButton, {
              disabled: isLoading,
              onClick: function onClick() {
                return onCtaClickReuseDebit(previousClaim.lastFour, previousClaim.externalCardId);
              },
              children: ["Cash out to card ending in ", previousClaim.lastFour]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChangeCardLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
            size: 'small',
            color: system/* colors.darkGrey */.O9.darkGrey,
            children: ["Not ", previousClaim.firstName, "? Need to", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* UnderlinedBoldGhostButton */.Ni, {
              onClick: onChangeCard,
              children: "change debit card?"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pay_PayAnyoneValueProps, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: errorDialogIsShowing && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorDialog, {
          children: errorMessage
        })
      })]
    })]
  });
}

var GreetingLayout = styled_components_browser_esm/* default.div */.ZP.div(ReturnUserLanding_templateObject || (ReturnUserLanding_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n  margin-bottom: 0.5rem;\n"])));
var ReturnUserLanding_CTALayout = styled_components_browser_esm/* default.div */.ZP.div(ReturnUserLanding_templateObject2 || (ReturnUserLanding_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  row-gap: 1rem;\n"])));
var ChangeCardLayout = styled_components_browser_esm/* default.div */.ZP.div(ReturnUserLanding_templateObject3 || (ReturnUserLanding_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 1rem;\n  text-align: center;\n"])));
var SecondaryButton = (0,styled_components_browser_esm/* default */.ZP)(components_Button/* AltButton */.vm)(ReturnUserLanding_templateObject4 || (ReturnUserLanding_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n"])), system/* colors.darkGreen */.O9.darkGreen);
var ReturnUserLanding_PrimaryButton = (0,styled_components_browser_esm/* default */.ZP)(components_Button/* StyledButton */.Sn)(ReturnUserLanding_templateObject5 || (ReturnUserLanding_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-shadow: 0 4px 12px rgba(51, 51, 51, 0.16);\n"])));
/* harmony default export */ var ReturnUser_ReturnUserLanding = (ReturnUserLanding);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/Request/ReceiveFromAnyoneValueProps.tsx


var ReceiveFromAnyoneValueProps_templateObject, ReceiveFromAnyoneValueProps_templateObject2, ReceiveFromAnyoneValueProps_templateObject3, ReceiveFromAnyoneValueProps_templateObject4, ReceiveFromAnyoneValueProps_templateObject5, ReceiveFromAnyoneValueProps_templateObject6, ReceiveFromAnyoneValueProps_templateObject7, ReceiveFromAnyoneValueProps_templateObject8, ReceiveFromAnyoneValueProps_templateObject9;









function ReceiveFromAnyoneValueProps() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneValueProps_P2pValuePropsLayout, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_PayAnyonePhoneLayout, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* PayAnyonePhone */.QO, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_P2pTitleLayout, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
        size: 'small',
        children: "Chime lets you pay friends and cash out instantly fee-free"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneValueProps_ListBoxLayout, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneValueProps_ListBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_IconLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ThreePeopleIcon */.vL, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_CenteredBlockText, {
          children: "Send and receive money fee-free, no matter what bank account they use"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneValueProps_ListBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_IconLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ScissorFeesIcon */.GC, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_CenteredBlockText, {
          children: "No cash-out fees for you or anyone"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneValueProps_ListBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_IconLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* CalendarIcon */.Qu, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_CenteredBlockText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
            children: ["Get paid up to 2 days early with direct deposit", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
              children: "1"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneValueProps_ListBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_IconLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* PadLockIcon */.e0, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneValueProps_CenteredBlockText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
            children: ["Your funds are FDIC-insured up to $250,000 through our bank partners", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
              children: "2"
            })]
          })
        })]
      })]
    })]
  });
}

var ReceiveFromAnyoneValueProps_P2pValuePropsLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneValueProps_templateObject || (ReceiveFromAnyoneValueProps_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 3vh 0 0 0;\n\n  ", "\n\n  ", "\n"])), media/* default.tinyMobileOnly */.Z.tinyMobileOnly(ReceiveFromAnyoneValueProps_templateObject2 || (ReceiveFromAnyoneValueProps_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 10vh 0 0 0;\n  "]))), media/* default.desktop */.Z.desktop(ReceiveFromAnyoneValueProps_templateObject3 || (ReceiveFromAnyoneValueProps_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 4rem 0 0 0;\n  "]))));
var ReceiveFromAnyoneValueProps_P2pTitleLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneValueProps_templateObject4 || (ReceiveFromAnyoneValueProps_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 1.5rem 0 2rem 0;\n"])));
var ReceiveFromAnyoneValueProps_ListBoxLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneValueProps_templateObject5 || (ReceiveFromAnyoneValueProps_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 1.5rem;\n"])));
var ReceiveFromAnyoneValueProps_PayAnyonePhoneLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneValueProps_templateObject6 || (ReceiveFromAnyoneValueProps_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 1.5rem;\n"])));
var ReceiveFromAnyoneValueProps_ListBox = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneValueProps_templateObject7 || (ReceiveFromAnyoneValueProps_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-column-gap: 1.5rem;\n  align-items: center;\n"])));
var ReceiveFromAnyoneValueProps_IconLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneValueProps_templateObject8 || (ReceiveFromAnyoneValueProps_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 80px;\n  width: 80px;\n  grid-column-start: 1;\n"])));
var ReceiveFromAnyoneValueProps_CenteredBlockText = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneValueProps_templateObject9 || (ReceiveFromAnyoneValueProps_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  grid-column-start: 2;\n"])));
/* harmony default export */ var Request_ReceiveFromAnyoneValueProps = (ReceiveFromAnyoneValueProps);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/Request/useReceiveFromAnyoneLandingPage.tsx






var useReceiveFromAnyoneLandingPage = function useReceiveFromAnyoneLandingPage() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId,
      senderId = userData.senderId,
      amount = userData.amount;

  var fireLandingPageViewedEvents = function fireLandingPageViewedEvents() {
    (0,trackingEvents/* trackLandingPageViewed */.TG)(amount, publicId, senderId, types/* ClaimFlowType.receive */.Tz.receive);
  };

  var fireCtaTappedEvents = function fireCtaTappedEvents(claimType) {
    return (0,trackingEvents/* trackCTATapped */.u)('P2P Request Payment', 'Get $', 'P2P Request Payment Landing Page', 'p2p_request_payment_get_money_button', publicId, claimType);
  };

  return Landing_useCreateLandingPageHook(fireCtaTappedEvents, fireLandingPageViewedEvents);
};

/* harmony default export */ var Request_useReceiveFromAnyoneLandingPage = (useReceiveFromAnyoneLandingPage);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/Request/ReceiveFromAnyoneLanding.tsx



var ReceiveFromAnyoneLanding_templateObject, ReceiveFromAnyoneLanding_templateObject2;













function ReceiveFromAnyoneLanding() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var name = userData.name,
      amount = userData.amount;

  var _useReceiveFromAnyone = Request_useReceiveFromAnyoneLandingPage(),
      onCtaClickDebit = _useReceiveFromAnyone.onCtaClickDebit;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Landing_LandingBase, {
    pageLocation: 'Request Payment Landing Page',
    claimFlowType: types/* ClaimFlowType.receive */.Tz.receive,
    landingTitle: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Title */.Dx, {
      size: 'large',
      children: ["Pay ", name, " $", amount]
    }),
    showHeaderLogin: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneLanding_CTALayout, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneLanding_PrimaryButton, {
        onClick: onCtaClickDebit,
        children: "Pay with your debit card"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Request_ReceiveFromAnyoneValueProps, {})]
  });
}

var ReceiveFromAnyoneLanding_CTALayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneLanding_templateObject || (ReceiveFromAnyoneLanding_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n  bottom: 0;\n"])));
var ReceiveFromAnyoneLanding_PrimaryButton = (0,styled_components_browser_esm/* default */.ZP)(components_Button/* StyledButton */.Sn)(ReceiveFromAnyoneLanding_templateObject2 || (ReceiveFromAnyoneLanding_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  box-shadow: 0 4px 12px rgba(51, 51, 51, 0.16);\n  position: relative;\n  height: auto;\n"])));
/* harmony default export */ var Request_ReceiveFromAnyoneLanding = (ReceiveFromAnyoneLanding);
;// CONCATENATED MODULE: ./src/components/SubPages/Landing/index.tsx



;// CONCATENATED MODULE: ./src/components/SubPages/Token/Pay/PayAnyoneToken.tsx



function PayAnyoneToken_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PayAnyoneToken_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PayAnyoneToken_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PayAnyoneToken_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var PF_TOKEN_COOKIE_NAME = 'pf_token';
var PF_PUBLIC_ID_COOKIE_NAME = 'pf_publicId';

function PayAnyoneToken(_ref) {
  var data = _ref.data,
      isError = _ref.isError;

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 2),
      userData = _useUserContext2[0],
      setUserContext = _useUserContext2[1];

  var _useMachine = (0,useMachine/* useMachine */.eO)(navigationMachine),
      _useMachine2 = (0,slicedToArray/* default */.Z)(_useMachine, 3),
      state = _useMachine2[0],
      send = _useMachine2[1],
      service = _useMachine2[2];

  var isMaintenanceModeEnabled = data.maintenanceMode; // We preset this variable so that we can listen to its change to set the context.
  // This component should be restructured as part of https://chime.atlassian.net/browse/PFG-853

  var senderInfo = null;
  (0,react.useEffect)(function () {
    if (data.previousClaim) {
      send('RETURN_USER_LANDING');
    } else {
      send('NEXT');
    }
  }, [data === null || data === void 0 ? void 0 : data.previousClaim, send]);

  var _useRouter = (0,next_router.useRouter)(),
      token = _useRouter.query.token;

  var _useCookies = (0,useCookies/* default */.Z)([PF_TOKEN_COOKIE_NAME, PF_PUBLIC_ID_COOKIE_NAME]),
      _useCookies2 = (0,slicedToArray/* default */.Z)(_useCookies, 2),
      setCookie = _useCookies2[1];

  (0,react.useEffect)(function () {
    if (senderInfo && !userData) {
      setUserContext(senderInfo);
    }
  }, [senderInfo, setUserContext, userData]);

  var ErrorFallback = function ErrorFallback(_ref2) {
    var _ref2$publicId = _ref2.publicId,
        publicId = _ref2$publicId === void 0 ? data.publicId : _ref2$publicId;
    (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Landing Page', 'Something went wrong', publicId);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Generic/* default */.Z, {});
  }; // Just so we keep track of the state


  if (false) {}

  if (isMaintenanceModeEnabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Error_MaintenanceMessage, {});
  }

  if (isError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorFallback, {
      publicId: null
    });
  }

  if (data.status === 'succeeded') {
    (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Landing Page', 'Payment claimed', data.publicId);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Claimed, {});
  }

  if (data.status === 'expired' || data.status === 'cancelled' || data.status === 'reversed') {
    (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('Landing Page', 'Transfer expired', data.publicId);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expired, {
      referralToken: data.sender.referralToken
    });
  }

  if (data.status === 'pending') {
    if (token !== state.context.token) {
      /**
       * We set a cookie here so consumer knows it needs to claim the PF
       * https://github.com/1debit/server-consumer/blob/3f03a8eae5453fc736ff5a53879db2686806c304/app/controllers/transactions_controller.rb#L968
       */
      setCookie(PF_TOKEN_COOKIE_NAME, token, {
        path: '/'
      });
      /**
       * We set the publicId cookie so we can track the user in enrollment
       */

      setCookie(PF_PUBLIC_ID_COOKIE_NAME, data.publicId, {
        path: '/'
      });
      send('TOKEN', {
        token: token,
        publicId: data.publicId
      });
    }

    senderInfo = {
      name: data.sender.name,
      amount: data.amount,
      memo: data.memo,
      bank: data.sender.bank,
      referralToken: data.sender.referralToken,
      publicId: data.publicId,
      senderId: data.sender.id,
      receiverIdentifier: data.receiverIdentifier,
      memoGifId: data.memoGifId,
      previousClaim: data.previousClaim,
      claimWithChime: data.claimWithChime,
      flipperFlags: data.flipperFlags,
      maintenanceMode: data.maintenanceMode
    }; // Checks to see if Receiver Identifier is a phone number

    if (senderInfo.receiverIdentifier.length === 10 && senderInfo.receiverIdentifier.indexOf('@') === -1) {
      setCookie('progressive_phone', senderInfo.receiverIdentifier, {
        path: '/'
      });
    }

    var handleError = function handleError(error, info) {
      var _window$Rollbar;

      (_window$Rollbar = window.Rollbar) === null || _window$Rollbar === void 0 ? void 0 : _window$Rollbar.error(error.message, error, info);
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorFallback, {
        publicId: data["public"]
      }),
      onError: handleError,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MachineContext.Provider, {
        value: service,
        children: state.matches('landing') ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pay_PayAnyoneLanding, {})
        }) : state.matches('returnUserLanding') ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReturnUser_ReturnUserLanding, {})
        }) : state.matches('claimInfo') ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Pay_PayAnyoneClaimInfo, {})
        }) : state.matches('confirmation') ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Confirmation/* PayAnyoneConfirmation */.w, {})
        }) : state.matches('error') ? /*#__PURE__*/(0,jsx_runtime.jsx)(PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContextualXState, PayAnyoneToken_objectSpread({}, senderInfo))
        }) : state.matches('loading') ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Generic/* default */.Z, {})
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorFallback, {});
}

var PageFadeInAnimation = function PageFadeInAnimation(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion_minimal.m.div, {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: {
        type: 'easeIn'
      },
      children: children
    }, 'confirmation')
  });
};

/* harmony default export */ var Pay_PayAnyoneToken = (PayAnyoneToken);
;// CONCATENATED MODULE: ./src/components/SubPages/Token/Request/useReceiveFromAnyoneToken.tsx









var useReceiveFromAnyoneToken_PF_TOKEN_COOKIE_NAME = 'pf_token';
var useReceiveFromAnyoneToken_PF_PUBLIC_ID_COOKIE_NAME = 'pf_publicId';
var ClaimStatus;

(function (ClaimStatus) {
  ClaimStatus["succeeded"] = "succeeded";
  ClaimStatus["expired"] = "expired";
  ClaimStatus["pending"] = "pending";
  ClaimStatus["sent"] = "sent";
  ClaimStatus["failed"] = "failed";
})(ClaimStatus || (ClaimStatus = {}));

var useReceiveFromAnyoneToken = function useReceiveFromAnyoneToken(data) {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 2),
      userData = _useUserContext2[0],
      setUserContext = _useUserContext2[1];

  var _useMachine = (0,useMachine/* useMachine */.eO)(navigationMachine),
      _useMachine2 = (0,slicedToArray/* default */.Z)(_useMachine, 3),
      state = _useMachine2[0],
      send = _useMachine2[1],
      service = _useMachine2[2];

  var _useRouter = (0,next_router.useRouter)(),
      token = _useRouter.query.token;

  var _useCookies = (0,useCookies/* default */.Z)([useReceiveFromAnyoneToken_PF_TOKEN_COOKIE_NAME, useReceiveFromAnyoneToken_PF_PUBLIC_ID_COOKIE_NAME]),
      _useCookies2 = (0,slicedToArray/* default */.Z)(_useCookies, 2),
      setCookie = _useCookies2[1];

  var claimStatus = getClaimStatus(data === null || data === void 0 ? void 0 : data.status, data === null || data === void 0 ? void 0 : data.payfriendStatus); // We preset this variable so that we can listen to its change to set the context.
  // This component should be restructured as part of https://chime.atlassian.net/browse/PFG-853

  var senderInfo = null;
  (0,react.useEffect)(function () {
    if (state.context.token) {
      send('NEXT');
    }
  }, [send, state.context.token]);
  (0,react.useEffect)(function () {
    if (senderInfo && !userData) {
      setUserContext(senderInfo);
    }
  }, [senderInfo, setUserContext, userData]);

  if (false) {}

  if (data.maintenanceMode) {
    return {
      isMaintenanceModeEnabled: true
    };
  }

  if (claimStatus === ClaimStatus.succeeded) {
    (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('P2P Receive Landing Page', 'Payment claimed', data.publicId);
  }

  if (claimStatus === ClaimStatus.expired) {
    (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('P2P Receive Landing Page', 'Transfer expired', data.publicId);
  }

  if (data) {
    senderInfo = {
      name: data.sender.name,
      amount: data.amount,
      memo: data.memo,
      bank: data.sender.bank,
      referralToken: data.sender.referralToken,
      publicId: data.publicId,
      senderId: data.sender.id,
      receiverIdentifier: data.receiverIdentifier,
      memoGifId: data.memoGifId,
      previousClaim: data.previousClaim,
      claimWithChime: data.claimWithChime,
      flipperFlags: data.flipperFlags
    };
  }

  if (claimStatus === ClaimStatus.pending) {
    if (token !== state.context.token) {
      /**
       * We set a cookie here so consumer knows it needs to claim the PF
       * https://github.com/1debit/server-consumer/blob/3f03a8eae5453fc736ff5a53879db2686806c304/app/controllers/transactions_controller.rb#L968
       */
      setCookie(useReceiveFromAnyoneToken_PF_TOKEN_COOKIE_NAME, token, {
        path: '/'
      });
      /**
       * We set the publicId cookie so we can track the user in enrollment
       */

      setCookie(useReceiveFromAnyoneToken_PF_PUBLIC_ID_COOKIE_NAME, data.publicId, {
        path: '/'
      });
      /**
       * Set cookie for progressive enrollment if Receiver Identifier is a phone number
       */

      if (data.receiverIdentifier.length === 10 && data.receiverIdentifier.indexOf('@') === -1) {
        setCookie('progressive_phone', data.receiverIdentifier, {
          path: '/'
        });
      }

      send('TOKEN', {
        token: token,
        publicId: data.publicId
      });
    }
  }

  return {
    isMaintenanceModeEnabled: false,
    claimStatus: claimStatus,
    navigationMachine: {
      state: state,
      service: service
    }
  };
};

function getClaimStatus(moneyRequestStatus, payAnyoneStatus) {
  if (moneyRequestStatus === types/* MoneyRequestStatus.pending */.sk.pending && payAnyoneStatus) {
    switch (payAnyoneStatus) {
      case types/* PayAnyoneStatus.succeeded */.KN.succeeded:
        return ClaimStatus.succeeded;

      case types/* PayAnyoneStatus.pending */.KN.pending:
        return ClaimStatus.pending;

      case types/* PayAnyoneStatus.sent */.KN.sent:
        return ClaimStatus.sent;

      case types/* PayAnyoneStatus.failed */.KN.failed:
        return ClaimStatus.failed;

      default:
        return null;
    }
  }

  switch (moneyRequestStatus) {
    case types/* MoneyRequestStatus.accepted */.sk.accepted:
      return ClaimStatus.succeeded;

    case types/* MoneyRequestStatus.cancelled */.sk.cancelled:
    case types/* MoneyRequestStatus.expired */.sk.expired:
      return ClaimStatus.expired;

    case types/* MoneyRequestStatus.pending */.sk.pending:
      return ClaimStatus.pending;

    default:
      return null;
  }
}

/* harmony default export */ var Request_useReceiveFromAnyoneToken = (useReceiveFromAnyoneToken);
;// CONCATENATED MODULE: ./src/components/SubPages/Token/Request/ReceiveFromAnyoneToken.tsx













function ReceiveFromAnyoneToken(_ref) {
  var data = _ref.data,
      isError = _ref.isError;

  var _useReceiveFromAnyone = Request_useReceiveFromAnyoneToken(data),
      isMaintenanceModeEnabled = _useReceiveFromAnyone.isMaintenanceModeEnabled,
      claimStatus = _useReceiveFromAnyone.claimStatus,
      navigationMachine = _useReceiveFromAnyone.navigationMachine;

  if (isMaintenanceModeEnabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Error_MaintenanceMessage, {});
  }

  var state = navigationMachine.state,
      service = navigationMachine.service;

  var ErrorFallback = function ErrorFallback(_ref2) {
    var _ref2$publicId = _ref2.publicId,
        publicId = _ref2$publicId === void 0 ? data.publicId : _ref2$publicId;
    (0,trackingEvents/* trackPayAnyoneReceiverError */.py)('P2P Receive Landing Page', 'Something went wrong', publicId);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Generic/* default */.Z, {
      showLogin: false
    });
  };

  if (isError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorFallback, {
      publicId: null
    });
  }

  if (claimStatus === ClaimStatus.succeeded) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Claimed, {});
  }

  if (claimStatus === ClaimStatus.expired) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expired, {
      referralToken: data.sender.referralToken
    });
  }

  if (claimStatus === ClaimStatus.pending) {
    var handleError = function handleError(error, info) {
      var _window$Rollbar;

      (_window$Rollbar = window.Rollbar) === null || _window$Rollbar === void 0 ? void 0 : _window$Rollbar.error(error.message, error, info);
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorFallback, {
        publicId: data["public"]
      }),
      onError: handleError,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MachineContext.Provider, {
        value: service,
        children: state.matches('landing') ? /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneToken_PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Request_ReceiveFromAnyoneLanding, {})
        }) : state.matches('claimInfo') ? /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneToken_PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Request_ReceiveFromAnyoneClaimInfo, {})
        }) : state.matches('confirmation') ? /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneToken_PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Confirmation/* ReceiveFromAnyoneConfirmation */.C, {})
        }) : state.matches('error') ? /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneToken_PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContextualXState, {
            showCta: false,
            showLogin: false
          })
        }) : state.matches('loading') ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneToken_PageFadeInAnimation, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Generic/* default */.Z, {
            showLogin: false
          })
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorFallback, {});
}

var ReceiveFromAnyoneToken_PageFadeInAnimation = function PageFadeInAnimation(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion_minimal.m.div, {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: {
        type: 'easeIn'
      },
      children: children
    }, 'page fade in')
  });
};

/* harmony default export */ var Request_ReceiveFromAnyoneToken = (ReceiveFromAnyoneToken);
;// CONCATENATED MODULE: ./src/components/SubPages/Token/index.tsx



/***/ }),

/***/ 88425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useGQLQuery; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4730);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6812);


var _excluded = ["onCompleted", "onError"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// Custom Apollo hook mirroring the SWR response structure
var useGQLQuery = function useGQLQuery(gqlQuery) {
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _onCompleted = config.onCompleted,
      _onError = config.onError,
      queryOptions = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(config, _excluded);

  var _useQuery = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(gqlQuery, _objectSpread(_objectSpread({}, variables), {}, {
    onCompleted: function onCompleted(data) {
      if (_onCompleted) _onCompleted(data); // Call the provided onCompleted callback, if any
    },
    onError: function onError(error) {
      if (_onError) _onError(error); // Call the provided onError callback, if any
    }
  }, queryOptions)),
      data = _useQuery.data,
      error = _useQuery.error,
      loading = _useQuery.loading,
      refetch = _useQuery.refetch; // Return data and error in SWR format


  return {
    data: data,
    error: error,
    loading: loading,
    refetch: refetch
  };
};

/***/ }),

/***/ 12193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ fetcher; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ky_universal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5737);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50186);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var fetcher = /*#__PURE__*/function () {
  var _ref = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, options) {
    var response;
    return _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,ky_universal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(url, _objectSpread({
              throwHttpErrors: false
            }, options));

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 9;
              break;
            }

            _context.t0 = Promise;
            _context.next = 7;
            return response.json();

          case 7:
            _context.t1 = _context.sent;
            return _context.abrupt("return", _context.t0.reject.call(_context.t0, _context.t1));

          case 9:
            return _context.abrupt("return", response.json());

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var SWROptions = {
  revalidateOnFocus: false
};

var useCustomSWR = function useCustomSWR(url) {
  return (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(url, fetcher, SWROptions);
};

/* harmony default export */ __webpack_exports__["Z"] = (useCustomSWR);

/***/ }),

/***/ 79392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useTokenInfo; }
});

// UNUSED EXPORTS: PAY_ANYONE_TOKEN_RESPONSE_QUERY

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/types/index.tsx + 1 modules
var types = __webpack_require__(20381);
// EXTERNAL MODULE: ./src/hooks/useSWR.ts
var useSWR = __webpack_require__(12193);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/utils/objectKeysToCase.ts


var objectKeysToCase = function objectKeysToCase(casing) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var convertKeysToCase = function convertKeysToCase(object) {
    if (!(0,lodash.isPlainObject)(object)) {
      return object;
    }

    var casingObject = (0,lodash.cloneDeep)(object); // Convert keys to case

    casingObject = (0,lodash.mapKeys)(casingObject, function (value, key) {
      return casing(key);
    }); // Recursively apply throughout object

    return (0,lodash.mapValues)(casingObject, function (value) {
      if ((0,lodash.isPlainObject)(value)) {
        return convertKeysToCase(value);
      }

      if ((0,lodash.isArray)(value)) {
        return (0,lodash.map)(value, convertKeysToCase);
      }

      return value;
    });
  };

  return convertKeysToCase;
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


function toCamelCase(input) {
  return objectKeysToCase(lodash.camelCase)(input);
} // eslint-disable-next-line @typescript-eslint/no-explicit-any

function toSnakeCase(input) {
  return objectKeysToCase(snakeCase)(input);
}
;// CONCATENATED MODULE: ./src/utils/graphql/massagePayAnyoneGetResponse.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function massagePayAnyoneGetResponse(graphqlData) {
  var _graphqlData$unauthen, _graphqlData$unauthen2, _graphqlData$unauthen3, _graphqlData$unauthen4;

  var pay_anyone_config_response = graphqlData === null || graphqlData === void 0 ? void 0 : (_graphqlData$unauthen = graphqlData.unauthenticated) === null || _graphqlData$unauthen === void 0 ? void 0 : (_graphqlData$unauthen2 = _graphqlData$unauthen.p2p) === null || _graphqlData$unauthen2 === void 0 ? void 0 : _graphqlData$unauthen2.pay_anyone_client_config;
  var payAnyoneConfigResponse = toCamelCase(pay_anyone_config_response);
  var dataConfig = cloneDeep_default()(payAnyoneConfigResponse);
  var pay_anyone_response = graphqlData === null || graphqlData === void 0 ? void 0 : (_graphqlData$unauthen3 = graphqlData.unauthenticated) === null || _graphqlData$unauthen3 === void 0 ? void 0 : (_graphqlData$unauthen4 = _graphqlData$unauthen3.p2p) === null || _graphqlData$unauthen4 === void 0 ? void 0 : _graphqlData$unauthen4.pay_anyone;
  var payAnyoneResponse = toCamelCase(pay_anyone_response);
  var data = cloneDeep_default()(payAnyoneResponse);

  if (data) {
    var _data$payFriend, _data$payFriend$uxSta, _data$flipperFlags;

    data.status = data === null || data === void 0 ? void 0 : (_data$payFriend = data.payFriend) === null || _data$payFriend === void 0 ? void 0 : (_data$payFriend$uxSta = _data$payFriend.uxStatus) === null || _data$payFriend$uxSta === void 0 ? void 0 : _data$payFriend$uxSta.toLowerCase();
    data.flipperFlags = dataConfig;
    data.maintenanceMode = data === null || data === void 0 ? void 0 : (_data$flipperFlags = data.flipperFlags) === null || _data$flipperFlags === void 0 ? void 0 : _data$flipperFlags.maintenanceModeEnabled;
    var payFriendValuesToKeep = data === null || data === void 0 ? void 0 : data.payFriend; // Delete the old keys? keep for now for testing
    // delete data?.payAnyoneClientConfig;
    // delete data?.payFriend;

    var transformedData = _objectSpread(_objectSpread({}, data), payFriendValuesToKeep);

    return transformedData;
  }
}
;// CONCATENATED MODULE: ./src/utils/graphql/fetchPayAnyoneShowResponse.ts

function fetchPayAnyoneShowResponse(graphqlData, graphqlError, graphqlLoading, refetch) {
  var _graphqlData$unauthen, _graphqlData$unauthen2;

  var payAnyoneData = graphqlData === null || graphqlData === void 0 ? void 0 : (_graphqlData$unauthen = graphqlData.unauthenticated) === null || _graphqlData$unauthen === void 0 ? void 0 : (_graphqlData$unauthen2 = _graphqlData$unauthen.p2p) === null || _graphqlData$unauthen2 === void 0 ? void 0 : _graphqlData$unauthen2.pay_anyone;

  switch (payAnyoneData === null || payAnyoneData === void 0 ? void 0 : payAnyoneData.__typename) {
    case 'PayAnyoneWithExternalCard':
      return {
        data: massagePayAnyoneGetResponse(graphqlData),
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: !!graphqlError,
        refetch: refetch
      };

    case 'PayAnyoneFetchError':
      return {
        data: payAnyoneData,
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: true,
        refetch: refetch
      };

    case 'StepUpRequiredError':
      return {
        data: payAnyoneData,
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: true,
        refetch: refetch
      };

    default:
      //eslint-disable-next-line no-console
      console.log('Received unexpected type:', payAnyoneData === null || payAnyoneData === void 0 ? void 0 : payAnyoneData.__typename);
      return {
        data: graphqlData,
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: !!graphqlError,
        refetch: refetch
      };
  }
}
// EXTERNAL MODULE: ./src/hooks/useGQLQuery.ts
var useGQLQuery = __webpack_require__(88425);
;// CONCATENATED MODULE: ./src/hooks/useTokenInfo.ts


var _templateObject;






var PAY_ANYONE_TOKEN_RESPONSE_QUERY = (0,lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query PayAnyoneByTokenResponse($token: String!) {\n    unauthenticated {\n      p2p {\n        pay_anyone_client_config {\n          maintenance_mode_enabled\n          ocr_enabled\n          graphql_usage {\n            use_gql_get_and_claim_pay_anyone\n          }\n        }\n        pay_anyone(token: $token) {\n          __typename\n          ... on PayAnyoneWithExternalCard {\n            claim_with_chime\n            pay_friend {\n              id\n              ux_status\n              amount\n              memo\n              memo_gif_id\n              expires_at\n              public_id\n              receiver_identifier\n            }\n            previous_claim {\n              external_card_id\n              first_name\n              last_four\n            }\n            recipient_previously_claimed\n            sender {\n              bank\n              id\n              referral_token\n              name\n            }\n          }\n          ... on PayAnyoneFetchError {\n            error_id\n            error_header\n            error_body\n          }\n          ... on StepUpRequiredError {\n            title\n            message\n            challenge_context\n          }\n        }\n      }\n    }\n  }\n"])));

function useTokenInfo(token, claimFlowType) {
  var _graphqlData$unauthen, _graphqlData$unauthen2, _graphqlData$unauthen3;

  var isPayAnyoneFlow = claimFlowType === types/* ClaimFlowType.pay */.Tz.pay;
  var fetchPath = isPayAnyoneFlow ? 'pf' : 'mr';
  var url = token && "".concat("", "/").concat(fetchPath, "/").concat(token, ".json");

  var _useSWR = (0,useSWR/* default */.Z)(url || null),
      data = _useSWR.data,
      error = _useSWR.error;

  var _useGQLQuery = (0,useGQLQuery/* useGQLQuery */.k)(PAY_ANYONE_TOKEN_RESPONSE_QUERY, {
    fetchPolicy: 'no-cache',
    variables: {
      token: token
    }
  }),
      graphqlData = _useGQLQuery.data,
      graphqlError = _useGQLQuery.error,
      graphqlLoading = _useGQLQuery.loading,
      refetch = _useGQLQuery.refetch;

  var _ref = (graphqlData === null || graphqlData === void 0 ? void 0 : (_graphqlData$unauthen = graphqlData.unauthenticated) === null || _graphqlData$unauthen === void 0 ? void 0 : (_graphqlData$unauthen2 = _graphqlData$unauthen.p2p) === null || _graphqlData$unauthen2 === void 0 ? void 0 : (_graphqlData$unauthen3 = _graphqlData$unauthen2.pay_anyone_client_config) === null || _graphqlData$unauthen3 === void 0 ? void 0 : _graphqlData$unauthen3.graphql_usage) || {},
      use_gql_get_and_claim_pay_anyone = _ref.use_gql_get_and_claim_pay_anyone;

  if (use_gql_get_and_claim_pay_anyone && isPayAnyoneFlow) {
    return fetchPayAnyoneShowResponse(graphqlData, graphqlError, graphqlLoading, refetch);
  } else {
    return {
      data: data,
      error: error,
      isLoading: !error && !data,
      isError: !!error
    };
  }
}

/* harmony default export */ var hooks_useTokenInfo = (useTokenInfo);

/***/ }),

/***/ 46601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 62678:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 25819:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24112:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);